<template>
  <span>
    <b-button variant="edit" @click="showTaskModal(task)" qid="delete-s-cancel-button" v-if="!fromHomepage">
      <span v-if="task">
        <font-awesome-icon icon="pen" />
      </span>
      <span v-if="!task">
        {{ $t('tasks.open_first_task') }}
      </span>
    </b-button>

    <b-button
        v-if="fromHomepage"
        class="icon-btn"
        variant="link"
        @click="showTaskModal(task)"
        qid="delete-s-cancel-button"
        v-b-tooltip.hover
        :title="$t('tasks.open_button')"
    >
      <font-awesome-icon icon="up-right-from-square" />
      <!-- <span v-if="task">
        {{ $t('tasks.open_button') }}
      </span>
      <span v-if="!task">
        {{ $t('tasks.open_first_task') }}
      </span> -->
    </b-button>

    <!-- Task modal -->
    <b-modal ref="task-modal" @hide="hideTaskModal" size="xl" modal-class="bottom-left task-modal multi-color-modal">

      <!-- HEADER -->
      <template #modal-header="{ close }" class="alert-menu-color text-white">
        <AssessmentGlobalSingleTaskModalHeader />
      </template>

      <AssessmentGlobalSingleTaskModalBody />

      <!-- FOOTER -->
      <template #modal-footer="{ close }">
        <AssessmentGlobalSingleTaskModalFooter ref="footer" />
      </template>
    </b-modal>

    <AssessmentGlobalSingleTaskModalAuxModals ref="auxModals" />

  </span>
</template>

<script>
import piincHttp from '@/util/configureAxios.js';
import Datepicker from 'vuejs-datepicker';
import { config } from '@/config.js';
import ConfirmRemoveAttachment from '@/components/ConfirmRemoveAttachment.vue';
import GuideViewModal from '@/components/guide/GuideViewModal.vue';
import roleCheck from '@/util/ACL/roleCheck';
import Avatar from '@/components/Avatar.vue';
import ShowMoreModal from '@/components/ShowMoreModal.vue';
// import draggable from 'vuedraggable'
import CreateObservationModal from '@/views/Projects/CreateObservationModal.vue';
import WordByWord from '@/components/WordByWord.vue';
// import AssessmentGlobalExpandable from '@/components/tasks/AssessmentGlobalExpandable.vue';
import UserInviteModal from '@/components/user/UserInviteModal.vue';
import ObservationViewModal from '@/views/Projects/ObservationViewModal.vue';
import MeasuresTable from '@/views/Projects/MeasuresTable.vue';
import AssessmentGlobalSingleTaskModalHeader from '@/views/Tasks/Assessment/AssessmentGlobalSingleTaskModalHeader.vue';
import AssessmentGlobalSingleTaskModalBody from '@/views/Tasks/Assessment/AssessmentGlobalSingleTaskModalBody.vue';
import AssessmentGlobalSingleTaskModalFooter from '@/views/Tasks/Assessment/AssessmentGlobalSingleTaskModalFooter.vue';
import AssessmentGlobalSingleTaskModalAuxModals from '@/views/Tasks/Assessment/AssessmentGlobalSingleTaskModalAuxModals.vue';

export default {
  name: 'AssessmentGlobalSingleTaskModal',
  data: function () {
    return {
      // Update Task variables
      taskForm: {
        remarks: '',
        notes: '',
        data_remarks: '',
        control_description: '',
        performed_text: '',
        testing_notes: '',
        rto: '',
        rpo: ''
      },
      testForm: {
        name: '',
        description: '',
        allow_description: '',
        allow_attachment: '',
        status: '',
        comment: '',
        description_data: ''
      },
      selectedTask: [],
      selectedTest: [],

      // Update Question variables
      form: {
        name: '',
        description: '',
        description_two: '',
        reference: '',
        control_objective: {},
        links: [],
        data_collection_links: [],
        data_collection_description: '',
        data_collection_description_two: ''
      },
      referenceInvalid: false,
      addControlDescription: [],
      addNotes: [],
      addTestingNotes: [],
      addPerformedText: [],
      addDescription: [],
      addResponse: [],
      addAttachments: [],
      data_collection_on: 0,
      responseType: [],
      responseTypeDoc: [],
      addResponseDoc: [],
      dataCollectionAddDescription: [],
      dataCollectionAddAttachments: [],
      showQuestionLinksSection: false,
      showQuestionTwoLinksSection: false,
      selectedTaskDependency: [],

      responseTypes: [
        {
          group: this.$t('maintenance.questions.answer_type.input_label'),
          items: [
            { name: this.$t('maintenance.questions.type.datepicker'), value: 'Datepicker' },
          ]
        },
        {
          group: this.$t('maintenance.questions.answer_type.dropdown_label'),
          items: [
            { name: this.$t('maintenance.questions.type.dropdown'), value: 'Dropdown' },
            { name: this.$t('maintenance.questions.type.yes/no'), value: 'Yes/No' }
          ]
        }
      ],
      allowTypes: [
        { name: this.$t('maintenance.questions.type.no'), value: 'No' },
        { name: this.$t('maintenance.questions.type.optional'), value: 'Optional' },
        { name: this.$t('maintenance.questions.type.mandatory'), value: 'Mandatory' },
      ],
      allowTypesDoc: [
        { name: this.$t('maintenance.questions.type.no'), value: 'No' },
        { name: this.$t('maintenance.questions.type.optional'), value: 'Optional' },
        { name: this.$t('maintenance.questions.type.mandatory'), value: 'Mandatory' },
        { name: this.$t('maintenance.questions.type.auditor'), value: 'Auditor' },
      ],
      testStatus: [
        { name: this.$t('testing.status.pending'), value: 'pending' },
        { name: this.$t('testing.status.documentation_collection_completed'), value: 'documentation_collection_completed' },
        { name: this.$t('testing.status.failed'), value: 'failed' },
        { name: this.$t('testing.status.passed'), value: 'passed' },
      ],
      allowTypesShort: [
        { name: this.$t('maintenance.questions.type.optional'), value: 'Optional' },
        { name: this.$t('maintenance.questions.type.mandatory'), value: 'Mandatory' },
      ],
      answerTypes: [
        {
          group: this.$t('maintenance.questions.answer_type.positive_negative_label'),
          items: [
            { name: this.$t('maintenance.questions.answer_type.neutral'), value: 'Neutral' },
            { name: this.$t('maintenance.questions.answer_type.positive'), value: 'Positive' },
            { name: this.$t('maintenance.questions.answer_type.negative'), value: 'Negative' },
          ]
        },
        {
          group: this.$t('maintenance.questions.answer_type.impact_assessment_label'),
          items: [
            { name: this.$t('maintenance.questions.answer_type.very_low'), value: 'Very low' },
            { name: this.$t('maintenance.questions.answer_type.low'), value: 'Low' },
            { name: this.$t('maintenance.questions.answer_type.high'), value: 'High' },
            { name: this.$t('maintenance.questions.answer_type.very_high'), value: 'Very high' },
          ]
        },
      ],
      yesNoOptions: [
        'Yes',
        'No'
      ],
      yesValue: [],
      noValue: [],
      dataCollectionOptions: [
        { text: this.$t('system.yes'), value: 1 },
        { text: this.$t('system.no'), value: 0 },
      ],
      selectedOptions: [],
      inputOption: '',
      positiveAnswers: [],
      negativeAnswers: [],

      // Framework Control variables
      selectedFrameworkControls: [],
      selectedFramework: [],
      selectedFrameworkControl: [],
      frameworkControlItems: [],
      frameworkItems: [],

      // Control Objective variables
      controlObjectives: [],
      selectedControlObjective: {},
      assessmentControlOpen: false,
      coForm: {
        name: '',
        description: ''
      },
      sTableItems: [],
      loadingObservations: true,
      perPage: '',
      selectedPerPage: "10",
      currentPage: 1,
      totalRows: 0,
      selectedObservation: {},
      viewObservationModal: false,
      itemToDelete: {},
      editForm: {
        name: '',
        description: '',
        scope_id: '',
        impact_assessment: ''
      },
      selectedImpact: [],
      scopeItems: [],
      selectedScope: [],
      // General variables
      buttonDisabled: false,
      selectedFile: {},
      selectedLink: {},
      selectedComment: {},
      showDeleteAttachmentModal: false,
      showDeleteLinkedAttachmentModal: false,
      showDeleteLinkModal: false,
      showDeleteCommentModal: false,
      showInput: false,
      showSingleLinkLabel: true,
      inputLink: '',
      inputLinkName: '',
      descriptionLength: config.descriptionLength,
      showFullProjectMessage: false,
      showFullTaskDescription: false,
      showFullDataCollectionDescription: false,
      showFullMainTaskDescriptionOne: false,
      showFullMainTaskDescriptionTwo: false,
      showFullGenericControlDescription: false,
      error: '',
      sizeError: '',
      taskList: [],
      selectedAnswer: [],
      selectedAnswerDoc: [],
      selectedDate: '',
      selectedDateDoc: '',
      selectedDataCollectionAnswer: [],
      allAnswers: [],
      allAnswersDoc: [],
      impactItems: [
        { name: this.$t('impact.very_low'), value: 'Very low' },
        { name: this.$t('impact.low'), value: 'Low' },
        { name: this.$t('impact.high'), value: 'High' },
        { name: this.$t('impact.very_high'), value: 'Very high' }
      ],
      intervalOptions: [
        { text: this.$t('system.interval_seconds'), value: 'Seconds' },
        { text: this.$t('system.interval_minutes'), value: 'Minutes' },
        { text: this.$t('system.interval_hours'), value: 'Hours' },
        { text: this.$t('system.interval_days'), value: 'Days' },
        { text: this.$t('system.interval_months'), value: 'Months' },
        { text: this.$t('system.interval_years'), value: 'Years' },
      ],
      selectedConfidentialityImpact: [],
      selectedIntegrityImpact: [],
      selectedAvailabilityImpact: [],
      rtoInterval: [],
      rpoInterval: [],
      project_progress: 0,
      taskCompleted: false,
      welcomeGuide: {},
      selectedGuide: {},
      viewGuideModal: false,
      selectedItem: {},
      showUsersModal: false,
      currentView: 'default',
      files: [],
      files_two: [],
      data_collection_files: [],
      test_files: [],
      data_collection_two_files: [],
      showLinksSection: false,
      showLinksSectionTwo: false,
      showDataCollectionLinksSection: false,
      uploader: false,
      showDropActive: false,
      userList: [],
      comment: '',
      reopenError: '',
      selectedAssignUsers: [],
      previousComments: [],
      qaComments: [],
      loadingComments: true,
      loadingQaComments: true,
      tests: [],
      loadingTests: true,
      showFullGuideDescription: false,
      wpGuide: {},
      wpGuideData: {},
      wpGuideSystem: {},
      myGuides: [],
      myGuidesData: [],
      myGuidesSystem: [],

      editModeResponse: false,
      editModeResponseDoc: false,
      editModeResponseDocMain: false,
      editModeNotes: false,
      editModeControlDescription: false,
      editModePerformedTest: false,
      editModeTestingNotes: false,
      editModeConclusion: false,
      editModeControlDescriptionDocumentationCollection: false,

      showFullTextNotes: false,
      showFullTextControlDescription: false,
      showFullTextPerformedTest: false,
      showFullTextTestingNotes: false,
      showFullTextConclusion: false,
      showFullTextControlDescriptionDocumentationCollection: false,

      assessmentGlobalExpandableShow: false,
      qa_comment: '',
      linkedControls: [],
      allLinkedMediaFiles: [],
      allLinkedDataMediaFiles: [],
      selectedLinkedMedia: [],
      selectedLinkedDataMedia: [],
      isControlDescriptionDrawerOpen: false,
      isFullAnalystDrawerOpen: false,
      isTestingDrawerOpen: false,
      testPlanAi: [],
      controlDescriptionAi: [],
      fullAnalystAi: [],
      ailoading: false,
      errorDescriptionDrawer: '',
      errorTestingDrawer: '',
      errorFullAnalystDrawer: '',
      timeLeft: 120,
      timerId: null,
      selectedLinkedControls: [],
      selectedLinkedControlsAsTarget: [],
      selectedLinkedControl: [],
      selectedAssessment: [],
      assessmentItems: [],
      assessmentControlItems: [],
      yesValueDoc: [],
      noValueDoc: [],
      selectedOptionsDoc: [],
      positiveAnswersDoc: [],
      negativeAnswersDoc: [],
      allAnswersCopyDoc: []
    }
  },
  props: {
    task: {},
    fromHomepage: {},
    controlObjective: {},
  },
  components: {
    Datepicker,
    ConfirmRemoveAttachment,
    GuideViewModal,
    Avatar,
    ShowMoreModal,
    // draggable,
    CreateObservationModal,
    UserInviteModal,
    // AssessmentGlobalExpandable,
    ObservationViewModal,
    MeasuresTable,
    WordByWord,
    AssessmentGlobalSingleTaskModalHeader,
    AssessmentGlobalSingleTaskModalBody,
    AssessmentGlobalSingleTaskModalFooter,
    AssessmentGlobalSingleTaskModalAuxModals
  },
  provide() {
    return {
      assessmentSingleTask: this
    };
  },
  computed: {
    getClient() {
      return this.$store.state.client;
    },
    getUser() {
      return this.$store.state.user;
    },
    getWordpressLink() {
      return this.$store.state.wordpressLink;
    },
    getReportMedia() {
      let media = [];

      if (this.selectedTask.project) {
        media = _.filter(this.selectedTask.project.media, function (mediaItem) {
          return mediaItem.collection_name == 'documents' || mediaItem.collection_name == 'project';
        });
      }


      return media;
    },
    getReportLinks() {
      let links = [];

      if (this.selectedTask.project) {
        links = _.filter(this.selectedTask.project.links, function (link) {
          return link.collection == null;
        });
      }

      return links;
    },
    formattedText() {
      // Replace newlines with <br><br> for HTML rendering
      return this.text.replace(/\n\n/g, '<br><br>').replace(/\n/g, '<br>');
    },
  },
  watch: {
    getClient: function () {

    },
    includeScheduled: function () {
      this.loadCA();
    }
  },
  methods: {
    getModalRef(name) {
      if (this.$refs && this.$refs[name]) {
        return this.$refs[name];
      }
      if (this.$refs && this.$refs.auxModals && this.$refs.auxModals.$refs) {
        if (this.$refs.auxModals.$refs[name]) {
          return this.$refs.auxModals.$refs[name];
        }
        const childRefs = Object.values(this.$refs.auxModals.$refs);
        for (const child of childRefs) {
          if (child && child.$refs && child.$refs[name]) {
            return child.$refs[name];
          }
        }
      }
      if (this.$refs && this.$refs.footer && this.$refs.footer.$refs) {
        return this.$refs.footer.$refs[name];
      }
      return null;
    },
    showModal(name) {
      const ref = this.getModalRef(name);
      if (ref && typeof ref.show === 'function') {
        ref.show();
      }
    },
    hideModal(name) {
      const ref = this.getModalRef(name);
      if (ref && typeof ref.hide === 'function') {
        ref.hide();
      }
    },
    handleType(value) {
      this.positiveAnswers = [];
      this.negativeAnswers = [];
      if (value && value.value === 'Dropdown' || value.value === 'System') {
        this.allAnswers = this.selectedOptions;
        this.allAnswersCopy = _.cloneDeep(this.allAnswers);
      } else {
        this.noValue = this.answerTypes[0].items[0];
        this.yesValue = this.answerTypes[0].items[0];
        this.allAnswers = this.yesNoOptions;
        this.allAnswersCopy = _.cloneDeep(this.allAnswers);
      }
    },
    handleTypeDoc(value) {
      this.positiveAnswersDoc = [];
      this.negativeAnswersDoc = [];
      if (value && value.value === 'Dropdown' || value.value === 'System') {
        this.allAnswers = this.selectedOptionsDoc;
        this.allAnswersCopy = _.cloneDeep(this.allAnswers);
      } else {
        this.noValue = this.answerTypes[0].items[0];
        this.yesValue = this.answerTypes[0].items[0];
        this.allAnswers = this.yesNoOptions;
        this.allAnswersCopy = _.cloneDeep(this.allAnswers);
      }
    },
    formatOptionLabel(option) {
      // Ensure reference and name are handled even if one is missing
      const reference = option.reference || '';
      const name = option.name || '';
      if (reference) {
        return `${reference}: ${name}`;
      } else {
        return `${name}`;
      }
    },
    loadAssessmentControlItems(query) {
      let self = this;

      piincHttp.get('questions', {
        params:
        {
          client: self.getClient.slug,
          per_page: 100,
          assessment: self.selectedAssessment.id
        }
      }).then(function (responseQuestions) {

        const globalIdToRemove = null;

        // Filter out questions that are already selected
        self.assessmentControlItems = responseQuestions.data.items.filter(
          question => question.id !== globalIdToRemove
        );

        if (self.assessmentControlItems && !self.assessmentControlItems.length && !query) {
          self.assessmentControlItems.push({ name: self.$t('system.no_results'), $isDisabled: true });
        }
      }, function () { });
    },
    linkedControlFormSubmit(evt) {
      let self = this;
      evt.preventDefault();

      let addToArray = false;

      if (self.selectedLinkedControl && self.selectedLinkedControl.id) {
        if (this.selectedLinkedControls.length) {
          _.forEach(this.selectedLinkedControls, function (item) {
            if (item.id !== self.selectedLinkedControl.id) {
              addToArray = true;
            }
          })
        } else {
          addToArray = true;
        }

        if (addToArray) {
          this.selectedLinkedControls.push(this.selectedLinkedControl);
        }

        this.hideAddLinkedControlModal();
      } else {
        this.error = this.$t('maintenance.questions.create.framework_control_error');
      }

    },
    handleAssessmentChange(item) {
      this.selectedAssessment = item;
      this.loadAssessmentControlItems();
    },
    loadAssessmentItems(query) {
      let self = this;
      piincHttp.get('assessments', {
        params:
        {
          client: this.getClient.slug,
          per_page: 100,
          keyword: query ? query : undefined
        }
      }).then(function (response) {
        self.assessmentItems = response.data.items
        if (self.assessmentItems && !self.assessmentItems.length && !query) {
          self.assessmentItems.push({ name: self.$t('system.no_results'), $isDisabled: true });
        }
      }, function () { });
    },
    showAddLinkedControlModal() {
      this.assessmentLinkedControlOpen = true;
      this.selectedAssessment = [];
      this.error = '';
      this.selectedLinkedControl = [];
      this.loadAssessmentItems();
      this.showModal('add-linked-control');
    },
    hideAddLinkedControlModal() {
      this.assessmentLinkedControlOpen = false;
      this.error = '';
      this.selectedAssessment = [];
      this.selectedLinkedControl = [];
      this.hideModal('add-linked-control');
    },
    startCountdown() {
      // Clear any existing timer to allow it to be restarted
      if (this.timerId) {
        clearInterval(this.timerId);
      }

      this.timeLeft = 120;

      // Store a reference to the component's 'this'
      const self = this;

      this.timerId = setInterval(function () {
        if (self.timeLeft > 0) {
          self.timeLeft--;
        } else {
          clearInterval(self.timerId);
        }
      }, 1000);
    },
    toggleTestingDrawer(type) {
      const wasClosed = !this.isTestingDrawerOpen;

      this.ailoading = false;

      this.isControlDescriptionDrawerOpen = false;
      this.isFullAnalystDrawerOpen = false;

      this.errorTestingDrawer = '';
      this.isTestingDrawerOpen = !this.isTestingDrawerOpen;

      if (wasClosed) {
        this.ailoading = true;
        this.startCountdown();
        let formData = new FormData();
        formData.append("task_id", this.selectedTask.id);
        formData.append("type", 'test_plan');

        piincHttp.post('openai/query', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
          .then(response => {
            this.testPlanAi = response.data.choices
            this.ailoading = false;
          })
          .catch(error => {
            console.error(error); // Handle the error
            this.errorTestingDrawer = error.status + ' ' + error.statusText;
            this.ailoading = false;
          });
      } else {
        this.testPlanAi = [];
      }

    },
    toggleControlDescriptionDrawer(type) {
      const wasClosed = !this.isControlDescriptionDrawerOpen;

      this.ailoading = false;

      this.isTestingDrawerOpen = false;
      this.isFullAnalystDrawerOpen = false;

      this.errorDescriptionDrawer = '';
      this.isControlDescriptionDrawerOpen = !this.isControlDescriptionDrawerOpen;

      if (wasClosed) {
        this.ailoading = true;
        this.startCountdown();
        let formData = new FormData();
        formData.append("task_id", this.selectedTask.id);
        formData.append("type", 'control_description');

        piincHttp.post('openai/query', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
          .then(response => {
            this.controlDescriptionAi = response.data.choices
            this.ailoading = false;
          })
          .catch(error => {
            console.error(error); // Handle the error
            this.errorDescriptionDrawer = error.status + ' ' + error.statusText;
            this.ailoading = false;
          });
      } else {
        this.controlDescriptionAi = [];
      }
    },
    toggleFullAnalystDrawer(type) {
      const wasClosed = !this.isFullAnalystDrawerOpen;

      this.isControlDescriptionDrawerOpen = false;
      this.isTestingDrawerOpen = false;

      this.ailoading = false;
      this.errorFullAnalystDrawer = '';
      this.isFullAnalystDrawerOpen = !this.isFullAnalystDrawerOpen;

      if (wasClosed) {
        this.ailoading = true;
        this.startCountdown();
        let formData = new FormData();
        formData.append("task_id", this.selectedTask.id);
        formData.append("type", 'full_analyst');

        piincHttp.post('openai/query', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
          .then(response => {

            this.fullAnalystAi = response.data.choices
            this.ailoading = false;
          })
          .catch(error => {
            console.error(error); // Handle the error
            this.errorFullAnalystDrawer = error.status + ' ' + error.statusText;
            this.ailoading = false;
          });
      } else {
        this.fullAnalystAi = [];
      }

    },
    loadQaComments() {
      let self = this;
      this.qaComments = []
      this.loadingQaComments = true;

      piincHttp.get('tasks/' + this.selectedTask.id + '/comments', {
        params:
        {
          client: this.getClient.id,
          per_page: 100,
          sort: 'created_at',
          order: 'asc',
          types: 'accepted,rejected,completed'
        }
      }).then(function (response) {
        self.qaComments = []

        _.forEach(response.data.items, function (item) {
          self.qaComments.push(item);
        })

        self.loadingQaComments = false;
      }, function () {
      });
    },
    loadTests() {
      let self = this;

      this.loadingTests = true;
      piincHttp.get('tasks/' + this.selectedTask.id + '/tests', {
        params:
        {
          per_page: 100,
          sort: 'created_at',
          order: 'asc'
        }
      }).then(function (response) {
        self.tests = []

        _.forEach(response.data.items, function (item) {
          self.tests.push(item);
        })

        self.loadingTests = false;
      }, function () {
      });
    },
    loadTest(testId) {
      let self = this;
      piincHttp.get('tasks/' + this.selectedTask.id + '/tests/' + testId, {
      }).then(function (response) {
        self.selectedTest = response.data

      }, function () {
      });
    },
    showQaLog() {
      let self = this;
      self.loadQaComments();
      self.showModal('qa-log');
    },
    hideQaLog() {
      let self = this;
      self.hideModal('qa-log');
    },
    showReopenQaTask() {
      let self = this;
      self.qa_comment = '';
      self.showModal('reopen-qa-task');
    },
    hideReopenQaTask() {
      let self = this;
      self.hideModal('reopen-qa-task');
    },
    showReopenQaTaskComplete() {
      let self = this;
      self.qa_comment = '';
      self.showModal('reopen-qa-task-complete');
    },
    hideReopenQaTaskComplete() {
      let self = this;
      self.hideModal('reopen-qa-task-complete');
    },
    reOpenQaTask() {
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;

      piincHttp.put('tasks/' + this.selectedTask.id, {
        status: 'pending',
        qa_status: 'rejected',
        qa_comment: self.qa_comment
      }).then(function (response) {
        self.selectedTask = response.data;
        self.buttonDisabled = false;
        self.$emit('reloadContent');
        self.hideModal('reopen-qa-task');
        self.loadQaComments()
      }, function (error) {

        self.buttonDisabled = false;
        self.error = error.data.message;

      })
    },
    completeOpenQaTask() {
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;

      piincHttp.put('tasks/' + this.selectedTask.id, {
        status: 'completed',
        qa_status: 'completed',
        qa_comment: self.qa_comment
      }).then(function (response) {
        self.selectedTask = response.data;
        self.buttonDisabled = false;
        self.hideModal('reopen-qa-task-complete');

        self.taskCompleted = true;
        self.$store.commit('storeTaskToolbarState', false);
        self.$emit('reloadContent');
        self.hideTaskModal();
      }, function (error) {

        self.buttonDisabled = false;
        self.error = error.data.message;

      })
    },
    acceptQaTask() {
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;

      piincHttp.put('tasks/' + this.selectedTask.id, {
        qa_status: 'accepted',
        qa_comment: 'accepted'
      }).then(function (response) {
        self.selectedTask = response.data;
        self.buttonDisabled = false;
        self.$emit('reloadContent');
        self.hideTaskModal();
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
    },
    // Edit modals
    showEditQForm1() {
      this.buttonDisabled = true;
      let self = this;
      self.showModal('edit-question-1');

      self.hideModal('edit-question-4');
      self.hideModal('edit-question-5');
      self.buttonDisabled = false;
    },
    showEditQForm2(type) {
      this.buttonDisabled = true;
      let self = this;
      self.error = '';

      if (type && type == 'forward') {
        if (self.form.name && self.form.name.length && this.selectedControlObjective && this.selectedControlObjective.id && !this.referenceInvalid) {
          self.hideModal('edit-question-1');

          self.showModal('edit-question-2');
          self.hideModal('edit-question-3');
        } else {
          self.error = ''
          if (!self.form.name.length) {
            this.error += ' ' + this.$t('maintenance.data_objects.create.name_error');
          }
          if (self.referenceInvalid) {
            this.error += ' ' + this.$t('maintenance.questions.create.reference_error_message');
          }
          if (!this.selectedControlObjective || (this.selectedControlObjective && !this.selectedControlObjective.id)) {
            this.error += ' ' + this.$t('maintenance.questions.create.control_objective_error_message');
          }
        }
      } else {
        self.hideModal('edit-question-2');

        self.showModal('edit-question-1');
        self.hideModal('edit-question-3');
      }

      self.buttonDisabled = false;
    },
    showEditQForm3(type) {
      this.buttonDisabled = true;
      let self = this;
      self.error = '';

      self.hideModal('edit-question-2');
      self.showModal('edit-question-3');
      self.hideModal('edit-question-4');

      self.buttonDisabled = false;
    },
    showEditQForm4(type) {
      this.buttonDisabled = true;
      let self = this;
      self.error = '';

      if (type && type == 'forward') {

        if ((self.data_collection_on && self.form.data_collection_description && self.form.data_collection_description.length && this.dataCollectionAddAttachments && this.dataCollectionAddDescription.value && this.dataCollectionAddAttachments && this.dataCollectionAddAttachments.value) || !self.data_collection_on) {
          self.hideModal('edit-question-1');

          self.showModal('edit-question-4');
          self.hideModal('edit-question-5');
        } else {
          self.error = ''
          if (!self.form.data_collection_description.length) {
            this.error += ' ' + this.$t('maintenance.questions.create.data_collection_description_error_message');
          }
          if (!this.dataCollectionAddDescription || (this.dataCollectionAddDescription && !this.dataCollectionAddDescription.value)) {
            this.error += ' ' + this.$t('maintenance.questions.create.add_description_error_message');
          }
          if (!this.dataCollectionAddAttachments || (this.dataCollectionAddAttachments && !this.dataCollectionAddAttachments.value)) {
            this.error += ' ' + this.$t('maintenance.questions.create.add_attachments_error_message');
          }
        }
      } else {
        self.hideModal('edit-question-4');

        self.showModal('edit-question-1');
        self.hideModal('edit-question-5');
      }

      self.buttonDisabled = false;
    },
    showEditQForm5() {
      this.assessmentControlOpen = true;
      this.buttonDisabled = true;
      let self = this;
      let sizeError = false;
      self.error = '';

      for (var i = 0; i < this.files.length; i++) {
        // Equal to 10 MB
        if (this.files[i].size > 31457280) {
          sizeError = true;
        }
      }

      if ((self.data_collection_on && self.form.data_collection_description && self.form.data_collection_description.length && this.dataCollectionAddAttachments && this.dataCollectionAddDescription.value && this.dataCollectionAddAttachments && this.dataCollectionAddAttachments.value) || !self.data_collection_on) {
        self.hideModal('edit-question-4');

        self.hideModal('edit-question-1');
        self.showModal('edit-question-5');
      } else {
        self.error = ''
        if (!self.form.data_collection_description.length) {
          this.error += ' ' + this.$t('maintenance.questions.create.data_collection_description_error_message');
        }
        if (!this.dataCollectionAddDescription || (this.dataCollectionAddDescription && !this.dataCollectionAddDescription.value)) {
          this.error += ' ' + this.$t('maintenance.questions.create.add_description_error_message');
        }
        if (!this.dataCollectionAddAttachments || (this.dataCollectionAddAttachments && !this.dataCollectionAddAttachments.value)) {
          this.error += ' ' + this.$t('maintenance.questions.create.add_attachments_error_message');
        }
      }

      self.buttonDisabled = false;
    },
    getDataCollectionTwoLinks() {
      let links = []

      links = _.filter(this.selectedQuestion.links, function (link) {
        return link.collection === 'data_collection_two';
      });

      return links;
    },
    handleEditDataCollectionLink() {
      let self = this;
      let formData = new FormData();

      if (!this.inputLinkDataCollection.startsWith('http')) {
        this.inputLinkDataCollection = 'https://' + this.inputLinkDataCollection;
      }

      formData.append("url", this.inputLinkDataCollection);
      formData.append("name", this.inputLinkNameDataCollection);
      formData.append("collection", "data_collection");
      formData.append("model_type", this.selectedQuestion.who_am_i);
      formData.append("model_id", this.selectedQuestion.id);

      piincHttp.post('links', formData).then(function () {
        self.$toastr('success', self.$t('maintenance.third_parties.link_add_success'));
        self.loadQuestion();
        self.inputLinkDataCollection = '';
        self.inputLinkNameDataCollection = '';
        self.showInput = false;
      }, function () {
      })
    },
    handleEditDataCollectionTwoLink() {
      let self = this;
      let formData = new FormData();

      if (!this.inputLinkDataCollection.startsWith('http')) {
        this.inputLinkDataCollection = 'https://' + this.inputLinkDataCollection;
      }

      formData.append("url", this.inputLinkDataCollection);
      formData.append("name", this.inputLinkNameDataCollection);
      formData.append("collection", "data_collection_two");
      formData.append("model_type", this.selectedQuestion.who_am_i);
      formData.append("model_id", this.selectedQuestion.id);

      piincHttp.post('links', formData).then(function () {
        self.$toastr('success', self.$t('maintenance.third_parties.link_add_success'));
        self.loadQuestion();
        self.inputLinkDataCollection = '';
        self.inputLinkNameDataCollection = '';
        self.showInput = false;
      }, function () {
      })
    },
    onFileChangeDataCollectionTwoEdit(files) {
      let self = this;
      let formData = new FormData();
      let sizeError = false;

      // Append list of attachments to FormData
      for (let i = 0; i < this.data_collection_files.length; i++) {
        // Equal to 10 MB
        if (this.data_collection_files[i].size > 31457280) {
          sizeError = true;
        }
        formData.append("document[]", this.data_collection_files[i].file);
      }

      formData.append("name", "documents");
      formData.append("collection", "data_collection_two");
      formData.append("model_type", this.selectedQuestion.who_am_i);
      formData.append("model_id", this.selectedQuestion.id);

      if (sizeError) {
        this.error = this.$t('system.file_size_30')
        this.data_collection_files = []
      } else {
        piincHttp.post('documents', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function () {
          self.$toastr('success', self.$t('maintenance.third_parties.media_add_success'));
          self.error = '';
          self.loadQuestion()
          // reset the model array
          self.data_collection_files = [];
        }, function (error) {
          self.error = error.data.message;
        })
      }
    },
    onFileChangeDataCollectionEdit(files) {
      let self = this;
      let formData = new FormData();
      let sizeError = false;

      // Append list of attachments to FormData
      for (let i = 0; i < this.data_collection_files.length; i++) {
        // Equal to 10 MB
        if (this.data_collection_files[i].size > 31457280) {
          sizeError = true;
        }
        formData.append("document[]", this.data_collection_files[i].file);
      }

      formData.append("name", "documents");
      formData.append("collection", "data_collection");
      formData.append("model_type", this.selectedQuestion.who_am_i);
      formData.append("model_id", this.selectedQuestion.id);

      if (sizeError) {
        this.error = this.$t('system.file_size_30')
        this.data_collection_files = []
      } else {
        piincHttp.post('documents', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function () {
          self.$toastr('success', self.$t('maintenance.third_parties.media_add_success'));
          self.error = '';
          self.loadQuestion()
          // reset the model array
          self.data_collection_files = [];
        }, function (error) {
          self.error = error.data.message;
        })
      }
    },
    getDataCollectionLinks() {
      let links = []

      links = _.filter(this.selectedQuestion.links, function (link) {
        return link.collection === 'data_collection';
      });

      return links;
    },
    hideEditQModal() {
      this.assessmentControlOpen = false;
      this.hideModal('edit-question-1');

      this.hideModal('edit-question-4');
      this.hideModal('edit-question-5');
    },
    showEditQModal(object) {
      let self = this;

      // -------------------------
      // Reset state
      // -------------------------
      this.error = '';

      this.selectedOptions = [];
      this.selectedOptionsDoc = [];
      this.inputOption = '';
      this.inputOptionDoc = '';
      this.positiveAnswers = [];
      this.negativeAnswers = [];
      this.positiveAnswersDoc = [];
      this.negativeAnswersDoc = [];

      this.allAnswers = [];
      this.allAnswersDoc = [];

      this.selectedControlObjective = [];
      this.selectedLinkedControls = [];
      this.selectedLinkedControlsAsTarget = [];
      this.selectedFrameworkControls = [];

      this.responseType = [];
      this.responseTypeDoc = [];

      this.selectedFiles = [];
      this.selectedFilesDoc = [];

      this.form.links = [];
      this.form.data_collection_links = [];

      this.inputLink = '';
      this.inputLinkName = '';
      this.inputLinkDataCollection = '';
      this.inputLinkNameDataCollection = '';

      this.data_collection_on = 0;
      this.showInput = true;
      this.showInputDoc = true;
      this.showOptionInput = true;
      this.referenceInvalid = false;

      this.form.name = '';
      this.form.description = '';
      this.form.description_two = '';
      this.form.data_collection_description = '';
      this.form.data_collection_description_two = '';
      this.form.reference = '';

      this.files = [];
      this.data_collection_files = [];
      this.data_collection_two_files = [];

      this.addDescription = [];
      this.addResponse = [];
      this.addResponseDoc = [];
      this.addControlDescription = [];
      this.addNotes = [];
      this.addTestingNotes = [];
      this.addPerformedText = [];
      this.addAttachments = [];
      this.dataCollectionAddDescription = [];
      this.dataCollectionAddAttachments = [];

      this.showLinksSection = false;
      this.showLinksSectionTwo = false;
      this.showQuestionLinksSection = false;
      this.showQuestionTwoLinksSection = false;

      this.selectedTaskDependency = [];
      this.selectedAnswers = [];

      // -------------------------
      // Framework controls
      // -------------------------
      if (object.framework_controls && object.framework_controls.length) {
        this.selectedFrameworkControls = _.cloneDeep(object.framework_controls);
      }

      // -------------------------
      // Response type (MAIN)
      // -------------------------
      if (object.response_type) {
        if (object.response_type === 'Datepicker') {
          this.responseType = _.find(this.responseTypes[0].items, i => i.value === object.response_type);
        } else {
          this.responseType = _.find(this.responseTypes[1].items, i => i.value === object.response_type);
        }
      }

      // -------------------------
      // Response type (DOC)
      // -------------------------
      if (object.response_type_doc) {
        if (object.response_type_doc === 'Datepicker') {
          this.responseTypeDoc = _.find(this.responseTypes[0].items, i => i.value === object.response_type_doc);
        } else {
          this.responseTypeDoc = _.find(this.responseTypes[1].items, i => i.value === object.response_type_doc);
        }
      }

      // -------------------------
      // Allow flags
      // -------------------------
      if (object.add_description) {
        this.addDescription = _.find(this.allowTypes, i => i.value === object.add_description);
      }

      if (object.add_response) {
        this.addResponse = _.find(this.allowTypes, i => i.value === object.add_response);
      }

      if (object.add_response_doc) {
        this.addResponseDoc = _.find(this.allowTypesDoc, i => i.value === object.add_response_doc);
      }

      if (object.add_notes) {
        this.addNotes = _.find(this.allowTypes, i => i.value === object.add_notes);
      }

      if (object.add_testing_notes) {
        this.addTestingNotes = _.find(this.allowTypes, i => i.value === object.add_testing_notes);
      }

      if (object.add_control_description) {
        this.addControlDescription = _.find(this.allowTypes, i => i.value === object.add_control_description);
      }

      if (object.add_performed_text) {
        this.addPerformedText = _.find(this.allowTypes, i => i.value === object.add_performed_text);
      }

      if (object.add_attachments) {
        this.addAttachments = _.find(this.allowTypes, i => i.value === object.add_attachments);
      }

      // -------------------------
      // Data collection toggles
      // -------------------------
      if (object.data_collection_add_description) {
        this.dataCollectionAddDescription = _.find(this.allowTypes, i => i.value === object.data_collection_add_description);
      } else {
        this.dataCollectionAddDescription = this.allowTypes[1];
      }

      if (object.data_collection_add_attachments) {
        this.dataCollectionAddAttachments = _.find(this.allowTypes, i => i.value === object.data_collection_add_attachments);
      } else {
        this.dataCollectionAddAttachments = this.allowTypes[1];
      }

      // -------------------------
      // MAIN response options
      // -------------------------
      if (object.response_type === 'Dropdown' && object.response_type_options) {
        this.selectedOptions = JSON.parse(object.response_type_options);
      }

      if (object.response_type === 'Yes/No' && object.response_type_options) {
        let array = JSON.parse(object.response_type_options);

        this.yesValue = array[0] && array[0].value ? array[0].value : '';
        this.noValue = array[1] && array[1].value ? array[1].value : '';
      }

      // -------------------------
      // DOC response options
      // -------------------------
      if (object.response_type_doc === 'Dropdown' && object.response_type_options_doc) {
        this.selectedOptionsDoc = JSON.parse(object.response_type_options_doc);
      }

      if (object.response_type_doc === 'Yes/No' && object.response_type_options_doc) {
        let array = JSON.parse(object.response_type_options_doc);

        this.yesValueDoc = array[0] && array[0].value ? array[0].value : '';
        this.noValueDoc = array[1] && array[1].value ? array[1].value : '';
      }

      // -------------------------
      // Linked controls
      // -------------------------
      this.selectedLinkedControls = Array.isArray(object.linked_controls)
        ? [...object.linked_controls]
        : [];

      this.selectedLinkedControlsAsTarget = Array.isArray(object.linkedControlsAsTarget)
        ? [...object.linkedControlsAsTarget]
        : [];

      // -------------------------
      // Dependency
      // -------------------------
      if (object.dependency_question_id) {
        this.selectedTaskDependency = _.find(this.tableItems, i => i.id === object.dependency_question_id);

        this.handleAnswers(this.selectedTaskDependency);

        if (object.dependency_question_answer) {
          _.forEach(object.dependency_question_answer, function (item) {
            self.selectedAnswers.push({ title: item, value: item });
          });
        }
      }

      // -------------------------
      // Control objective
      // -------------------------
      if (object.control_objective && object.control_objective.id) {
        this.selectedControlObjective = object.control_objective;
      }

      // -------------------------
      // Assign form values
      // -------------------------
      this.form.slug = object.slug;
      this.form.name = object.title;
      this.form.description = object.description;
      this.form.description_two = object.description_two;
      this.form.data_collection_description = object.data_collection_description || '';
      this.form.data_collection_description_two = object.data_collection_description_two || '';
      this.form.reference = object.reference;

      this.data_collection_on = object.data_collection_on;

      // -------------------------
      // Show modal
      // -------------------------
      this.showEditQForm1();
    },
    editFormSubmit(evt) {
      this.buttonDisabled = true;
      let self = this;
      evt.preventDefault();

      let form = {};

      // -------------------------
      // Basic fields
      // -------------------------
      form.title = this.form.name;
      form.reference = this.form.reference;
      form.description = this.form.description;
      form.description_two = this.form.description_two;

      // -------------------------
      // Data collection
      // -------------------------
      if (this.data_collection_on) {
        form.data_collection_on = this.data_collection_on;
        form.data_collection_description = this.form.data_collection_description;
        form.data_collection_description_two = this.form.data_collection_description_two;

        if (this.dataCollectionAddDescription && this.dataCollectionAddDescription.value) {
          form.data_collection_add_description = this.dataCollectionAddDescription.value;
        }

        if (this.dataCollectionAddAttachments && this.dataCollectionAddAttachments.value) {
          form.data_collection_add_attachments = this.dataCollectionAddAttachments.value;
        }
      } else {
        form.data_collection_on = 0;
      }

      // -------------------------
      // Response types
      // -------------------------
      if (this.responseType && this.responseType.value) {
        form.response_type = this.responseType.value;
      }

      if (this.responseTypeDoc && this.responseTypeDoc.value) {
        form.response_type_doc = this.responseTypeDoc.value;
      }

      // -------------------------
      // Toggles
      // -------------------------
      if (this.addDescription && this.addDescription.value) {
        form.add_description = this.addDescription.value;
      }

      if (this.addResponse && this.addResponse.value) {
        form.add_response = this.addResponse.value;
      }

      if (this.addResponseDoc && this.addResponseDoc.value) {
        form.add_response_doc = this.addResponseDoc.value;
      }

      if (this.addControlDescription && this.addControlDescription.value) {
        form.add_control_description = this.addControlDescription.value;
      }

      if (this.addNotes && this.addNotes.value) {
        form.add_notes = this.addNotes.value;
      }

      if (this.addTestingNotes && this.addTestingNotes.value) {
        form.add_testing_notes = this.addTestingNotes.value;
      }

      if (this.addPerformedText && this.addPerformedText.value) {
        form.add_performed_text = this.addPerformedText.value;
      }

      if (this.addAttachments && this.addAttachments.value) {
        form.add_attachments = this.addAttachments.value;
      }

      // -------------------------
      // Control objective
      // -------------------------
      if (this.selectedControlObjective && this.selectedControlObjective.id) {
        form.control_objective_id = this.selectedControlObjective.id;
      }

      // -------------------------
      // Response options (MAIN)
      // -------------------------
      if (this.responseType && this.responseType.value === 'Yes/No') {
        form.response_type_options = JSON.stringify([
          { title: 'Yes', value: this.yesValue },
          { title: 'No', value: this.noValue },
        ]);
      }

      if (this.responseType && this.responseType.value === 'Dropdown') {
        form.response_type_options = this.selectedOptions && this.selectedOptions.length
          ? JSON.stringify(this.selectedOptions)
          : '[]';
      }

      // -------------------------
      // Response options (DOC)
      // -------------------------
      if (this.responseTypeDoc && this.responseTypeDoc.value === 'Yes/No') {
        form.response_type_options_doc = JSON.stringify([
          { title: 'Yes', value: this.yesValueDoc },
          { title: 'No', value: this.noValueDoc },
        ]);
      }

      if (this.responseTypeDoc && this.responseTypeDoc.value === 'Dropdown') {
        form.response_type_options_doc = this.selectedOptionsDoc && this.selectedOptionsDoc.length
          ? JSON.stringify(this.selectedOptionsDoc)
          : '[]';
      }

      // -------------------------
      // Framework controls
      // -------------------------
      if (this.selectedFrameworkControls && this.selectedFrameworkControls.length) {
        form.framework_controls = this.selectedFrameworkControls.map(fc => fc.id);
      }

      // -------------------------
      // Linked controls
      // -------------------------
      form.linked_controls = [];
      if (this.selectedLinkedControls && this.selectedLinkedControls.length) {
        form.linked_controls = this.selectedLinkedControls.map(lc => lc.id);
      }

      // -------------------------
      // Dependency
      // -------------------------
      if (this.selectedTaskDependency && this.selectedTaskDependency.id) {
        form.dependency_question_id = this.selectedTaskDependency.id;
        form.dependency_question_answer = this.selectedAnswers.map(a => a.title);
      } else {
        form.dependency_question_id = '';
      }

      // -------------------------
      // Validation
      // -------------------------
      if (
        (
          (this.responseType && this.responseType.value) ||
          (this.addResponse && this.addResponse.value === 'No')
        ) &&
        this.form.description.length &&
        this.addDescription && this.addDescription.value &&
        this.addResponse && this.addResponse.value &&
        this.addControlDescription && this.addControlDescription.value &&
        this.addNotes && this.addNotes.value &&
        this.addPerformedText && this.addPerformedText.value &&
        this.addAttachments && this.addAttachments.value &&
        (
          (this.addResponse && this.addResponse.value === 'No') ||
          (this.responseType && ['Datepicker', 'Yes/No'].includes(this.responseType.value)) ||
          (this.responseType && this.responseType.value === 'Dropdown' && this.selectedOptions && this.selectedOptions.length) ||
          (this.responseTypeDoc && ['Datepicker', 'Yes/No'].includes(this.responseTypeDoc.value)) ||
          (this.responseTypeDoc && this.responseTypeDoc.value === 'Dropdown' && this.selectedOptionsDoc && this.selectedOptionsDoc.length)
        )
      ) {
        // -------------------------
        // Submit
        // -------------------------
        piincHttp.put('tasks/' + this.selectedTask.id, form).then(
          function (response) {
            self.$toastr('success', self.$t('maintenance.questions.update.success'));
            self.$emit('reloadContent');

            self.selectedTask = response.data;
            self.allAnswers = self.selectedTask.response_type_options
              ? JSON.parse(self.selectedTask.response_type_options)
              : [];
            self.allAnswersDoc = self.selectedTask.response_type_options_doc
              ? JSON.parse(self.selectedTask.response_type_options_doc)
              : [];

            self.hideEditQModal();
            self.buttonDisabled = false;
          },
          function (error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
            }
          }
        );
      } else {
        // -------------------------
        // Errors
        // -------------------------
        this.error = '';
        self.buttonDisabled = false;

        if (!this.responseType || !this.responseType.value) {
          this.error += ' ' + this.$t('maintenance.questions.create.response_type_error_message');
        }
        if (!this.addDescription || !this.addDescription.value) {
          this.error += this.$t('maintenance.questions.create.add_description_error_message');
        }
        if (!this.addResponse || !this.addResponse.value) {
          this.error += this.$t('maintenance.questions.create.add_response_error_message');
        }
        if (!this.addAttachments || !this.addAttachments.value) {
          this.error += this.$t('maintenance.questions.create.add_attachments_error_message');
        }
        if ((this.responseType && this.responseType.value === 'Select') && this.selectedOptions && !this.selectedOptions.length) {
          this.error += this.$t('maintenance.questions.create.selected_options_error_message');
        }
      }
    },
    createTestFormSubmit(evt) {
      let self = this;
      evt.preventDefault();
      self.buttonDisabled = false;

      let formData = new FormData();

      formData.append("name", self.testForm.name);
      formData.append("description", self.testForm.description);
      formData.append("status", 'pending');
      formData.append("allow_description", self.testForm.allow_description.value);
      formData.append("allow_attachment", self.testForm.allow_attachment.value);

      piincHttp.post('tasks/' + self.selectedTask.id + '/tests', formData).then(function () {
        self.loadTests();
      }, function () {
      })
    },
    updateTestFormSubmit(evt) {
      let self = this;
      evt.preventDefault();
      self.buttonDisabled = false;

      let formData = new FormData();

      formData.append("name", self.testForm.name);
      formData.append("description", self.testForm.description);

      formData.append("allow_description", self.testForm.allow_description.value);
      formData.append("allow_attachment", self.testForm.allow_attachment.value);
      formData.append("_method", 'put');

      piincHttp.post('tasks/' + self.selectedTask.id + '/tests/' + this.selectedTest.id, formData).then(function () {
        self.loadTests();
        self.hideModal('update-test');
      }, function () {
      })
    },
    saveWithoutComplete(evt) {
      evt.preventDefault();
      this.updateSmallTestFormSubmit(false); // Pass flag if needed
    },
    completeSubmission(evt) {
      evt.preventDefault();
      this.updateSmallTestFormSubmit(true); // Pass flag if needed
    },
    updateSmallTestFormSubmit(isComplete) {
      let self = this;

      self.buttonDisabled = false;

      let formData = new FormData();

      formData.append("_method", 'put');

      if (isComplete) {
        formData.append("status", 'documentation_collection_completed');
      } else {
        if (self.testForm.status && self.testForm.status.value) {
          formData.append("status", self.testForm.status.value);
        } else {
          formData.append("status", 'pending');
        }
      }

      if (self.testForm.comment) {
        formData.append("comment", self.testForm.comment);
      }

      if (self.testForm.description_data) {
        formData.append("description_data", self.testForm.description_data);
      }


      piincHttp.post('tasks/' + self.selectedTask.id + '/tests/' + this.selectedTest.id, formData).then(function () {
        self.loadTests();
        self.hideModal('show-test');
      }, function () {
      })
    },
    confirmDeleteTest(object) {
      let self = this;
      piincHttp.delete('tasks/' + self.selectedTask.id + '/tests/' + object.id).then(function (response) {
        self.hideTestConfirmDeleteModal();
        self.loadTests();
        // Trigger toastr message after modal close
        self.$toastr('success', self.$t('projects.delete.success'))
      }, function () { });
    },
    showAddFrameworkControlModal() {
      this.assessmentControlOpen = true;
      this.selectedFramework = [];
      this.error = '';
      this.selectedFrameworkControl = [];
      this.loadFrameworkItems();
      this.showModal('add-framework-control');
    },
    showTestCreateModal() {
      this.selectedTest = [];
      this.testForm.name = '';
      this.testForm.description = '';
      this.allow_description = [];
      this.allow_attachment = [];
      this.showModal('create-test');
    },
    showEditTestModal(test) {
      this.selectedTest = test;
      this.testForm.name = test.name;
      this.testForm.description = test.description;

      this.allow_description = [];
      if (test.allow_description) {
        this.testForm.allow_description = _.find(this.allowTypes, function (item) {
          return item.value === test.allow_description;
        });
      }
      this.allow_attachment = [];
      if (test.allow_attachment) {
        this.testForm.allow_attachment = _.find(this.allowTypes, function (item) {
          return item.value === test.allow_attachment;
        });
      }
      this.showModal('update-test');
    },
    openTestModal(test, type) {
      this.selectedTest = test;
      this.testForm.name = test.name;
      this.testForm.status = test.status;
      this.testForm.description = test.description;
      this.testForm.description_data = test.description_data;
      if (!this.testForm.description_data || !this.testForm.description_data.length) {

        if (this.currentView == 'data_collection' && (test.status == 'passed' || test.status == 'failed')) {
          this.editModeControlDescriptionDocumentationCollection = false;
        } else {
          this.editModeControlDescriptionDocumentationCollection = true;
        }

      } else {
        this.editModeControlDescriptionDocumentationCollection = false;
      }



      this.testForm.comment = test.comment;
      this.testForm.type = type;
      this.status = [];
      if (test.status) {
        this.testForm.status = _.find(this.testStatus, function (item) {
          return item.value === test.status;
        });
      }
      this.allow_description = [];
      if (test.allow_description) {
        this.testForm.allow_description = _.find(this.allowTypes, function (item) {
          return item.value === test.allow_description;
        });
      }
      this.allow_attachment = [];
      if (test.allow_attachment) {
        this.testForm.allow_attachment = _.find(this.allowTypes, function (item) {
          return item.value === test.allow_attachment;
        });
      }

      this.showModal('show-test');
    },
    hideAddFrameworkControlModal() {
      this.assessmentControlOpen = false;
      this.error = '';
      this.selectedFramework = [];
      this.selectedFrameworkControl = [];
      this.hideModal('add-framework-control');
    },
    handleFrameworkChange(item) {
      this.selectedFramework = item;
      this.loadFrameworkControlItems();
    },
    loadFrameworkItems(query) {
      let self = this;
      piincHttp.get('frameworks', {
        params:
        {
          client: this.getClient.slug,
          per_page: 100,
          keyword: query ? query : undefined
        }
      }).then(function (response) {
        self.frameworkItems = response.data.items;
        if (self.frameworkItems && !self.frameworkItems.length && !query) {
          self.frameworkItems.push({ name: self.$t('system.no_results'), $isDisabled: true });
        }
      }, function () {
      });
    },
    loadFrameworkControlItems(query) {
      let self = this;
      piincHttp.get('framework-controls', {
        params:
        {
          client: this.getClient.slug,
          per_page: 100,
          framework: this.selectedFramework.id,
          keyword: query ? query : undefined
        }
      }).then(function (response) {
        self.frameworkControlItems = response.data.items;
        if (self.frameworkControlItems && !self.frameworkControlItems.length && !query) {
          self.frameworkControlItems.push({ name: self.$t('system.no_results'), $isDisabled: true });
        }
      }, function () {
      });
    },
    frameworkControlFormSubmit(evt) {
      let self = this
      evt.preventDefault();

      let addToArray = false;

      if (self.selectedFrameworkControl && self.selectedFrameworkControl.id) {
        if (this.selectedFrameworkControls.length) {
          _.forEach(this.selectedFrameworkControls, function (item, index) {
            if (item.id != self.selectedFrameworkControl.id) {
              addToArray = true;
            }
          })
        } else {
          addToArray = true;
        }

        if (addToArray) {
          this.selectedFrameworkControls.push(this.selectedFrameworkControl);
        }

        this.hideAddFrameworkControlModal();
      } else {
        this.error = this.$t('maintenance.questions.create.framework_control_error');
      }

    },
    showCreateControlObjectiveModal() {
      this.coForm.name = '';
      this.coForm.description = '';
      this.error = '';
      this.showModal('add-control-objective');
    },
    hideCreateControlObjectiveModal() {
      this.coForm.name = '';
      this.coForm.description = '';
      this.error = '';
      this.loadCO();
      this.hideModal('add-control-objective');
    },
    coFormSubmit(evt) {
      this.buttonDisabled = true;
      // let formData = new FormData();

      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;
      evt.preventDefault();

      this.coForm.client = this.getClient.slug;
      this.coForm.project_id = this.selectedTask.project.id;

      piincHttp.post('/project-control-objectives', this.coForm).then(function (response) {
        self.hideCreateControlObjectiveModal();
        self.selectedControlObjective = response.data

        self.$emit('reloadContent');
        self.buttonDisabled = false;

        self.$toastr('success', self.$t('maintenance.control_objective.create.success'))
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
    },
    loadCO() {
      let self = this;
      piincHttp.get('/assessment-control-objectives', {
        params:
        {
          client: this.getClient.slug,
          assessment: this.selectedTask.project.assessment.id,
          per_page: 100,
          // keyword: query ? query : undefined
        }
      }).then(function (response) {
        self.controlObjectives = response.data.items;

        if (self.controlObjectives && !self.controlObjectives.length && !query) {
          self.controlObjectives.push({ name: self.$t('system.no_results'), $isDisabled: true });
        }
      }, function () {
      });
    },
    lockSwitch(lockStatus) {
      let self = this;
      if (lockStatus) {
        this.data_collection_on = 0;
      } else {
        this.data_collection_on = 1;
      }
    },
    handleOption(evt) {
      evt.preventDefault();
      // If there's a link in input, add it to links array
      if (this.inputOption !== '') {
        this.selectedOptions.push({ title: this.inputOption, value: this.answerTypes[0].items[0] })
        // Reset link input form
        this.inputOption = ''
      }
      this.showOptionInput = false;
    },
    getMedia(type) {
      let media = [];
      if (type == 'task') {
        media = _.filter(this.selectedTask.media, function (mediaItem) {
          return mediaItem.collection_name == 'documents';
        });
      }

      if (type == 'data_documents') {
        media = _.filter(this.selectedTask.media, function (mediaItem) {
          return mediaItem.collection_name == 'data_documents';
        });
      }

      if (type == 'task_and_data_collection') {
        media = _.filter(this.selectedTask.media, function (mediaItem) {
          return mediaItem.collection_name == 'documents' || mediaItem.collection_name == 'data_documents';
        });
      }

      if (type == 'question') {
        media = _.filter(this.selectedTask.media, function (mediaItem) {
          return mediaItem.collection_name == 'question';
        });
      }

      if (type == 'data_collection') {
        media = _.filter(this.selectedTask.media, function (mediaItem) {
          return mediaItem.collection_name == 'data_collection';
        });
      }
      return media;
    },
    getTestMedia(type) {
      let media = [];

      if (this.selectedTest.media && type == 'documents') {
        media = _.filter(this.selectedTest.media, function (mediaItem) {
          return mediaItem.collection_name == 'documents';
        });
      }
      return media;
    },
    getDifference(endDate) {
      var moment = require('moment');
      let currentDate = moment();
      endDate = moment(endDate);
      let difference = endDate.diff(currentDate, 'days');
      return difference;
    },
    openGuide() {
      if (this.wpGuide && this.wpGuide.link) {
        window.open(this.wpGuide.link, '_blank');
      }
    },
    getGuide(code) {
      let existingGuide = _.find(this.myGuides, function (object) {
        return object.scope == code && object.type == 'Task' && object.enabled;
      });
      return existingGuide;
    },
    loadGuides(code) {
      let self = this;
      let language = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en';

      piincHttp.get('guides', {
        params:
        {
          per_page: 1,
          language: 'en',
          type: 'Task',
          scope: code,
          client: this.getClient.slug
        }
      }).then(function (response) {
        if (response.data.items.length) {
          self.myGuides.push(response.data.items[0]);
          piincHttp.get(self.getWordpressLink + response.data.items[0].external_id).then(function (response) {
            self.wpGuide = response.data;
          }, function () {
          });
        }
      }, function () {
      });
    },
    loadGuidesData(code) {
      let self = this;
      let language = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en';

      piincHttp.get('guides', {
        params:
        {
          per_page: 1,
          language: 'en',
          type: 'Task',
          scope: code,
          client: this.getClient.slug
        }
      }).then(function (response) {
        if (response.data.items.length) {
          self.myGuides.push(response.data.items[0]);
          piincHttp.get(self.getWordpressLink + response.data.items[0].external_id).then(function (response) {
            self.wpGuideData = response.data;
          }, function () {
          });
        }
      }, function () {
      });
    },
    loadGuidesSystem(code) {
      let self = this;
      let language = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en';

      piincHttp.get('guides', {
        params:
        {
          per_page: 1,
          language: 'en',
          type: 'Task',
          scope: code,
          client: this.getClient.slug
        }
      }).then(function (response) {
        if (response.data.items.length) {
          self.myGuides.push(response.data.items[0]);
          piincHttp.get(self.getWordpressLink + response.data.items[0].external_id).then(function (response) {
            self.wpGuideSystem = response.data;
          }, function () {
          });
        }
      }, function () {
      });
    },
    getLinks(type) {
      let links = [];
      if (type == 'task') {
        links = _.filter(this.selectedTask.links, function (link) {
          return link.collection == 'task';
        });
      }

      if (type == 'question') {
        links = _.filter(this.selectedTask.links, function (link) {
          return link.collection == 'question' || link.collection == null;
        });
      }

      if (type == 'data_documents') {
        links = _.filter(this.selectedTask.links, function (link) {
          return link.collection == 'data_documents';
        });
      }

      if (type == 'task_and_data_collection') {
        links = _.filter(this.selectedTask.links, function (link) {
          return link.collection == 'data_documents' || link.collection == 'task';
        });
      }

      if (type == 'data_collection') {
        links = _.filter(this.selectedTask.links, function (link) {
          return link.collection == 'data_collection';
        });
      }
      return links;
    },
    getReducedUsers(users) {
      let reducedUsers = [];
      if (users) {
        if (users.length > 3) {
          reducedUsers = _.cloneDeep(users);
          reducedUsers = reducedUsers.slice(0, 3);
        } else {
          reducedUsers = users;
        }
      }
      return reducedUsers;
    },
    getIcon(object) {
      let foundObject = {};
      let responseOptions = JSON.parse(object.response_type_options);
      foundObject = _.find(responseOptions, function (item) {
        return item.title === object.response;
      });

      if (foundObject) {
        return foundObject.value.value;
      } else {
        return '';
      }

    },
    getIconDoc(object) {
      let foundObject = {};
      let responseOptions = JSON.parse(object.response_type_options_doc);
      foundObject = _.find(responseOptions, function (item) {
        return item.title === object.response_doc;
      });

      if (foundObject) {
        return foundObject.value.value;
      } else {
        return '';
      }

    },
    showCreateLinkModal(object) {
      let self = this;
      this.error = '';
      this.buttonDisabled = false;

      this.showModal('add-link');
    },
    hideCreateLinkModal() {
      this.hideModal('add-link');
    },
    reloadUserList() {
      this.loadUsers();
    },
    loadUsers(query) {
      let self = this;

      this.buttonDisabled = true;

      piincHttp.get('users', {
        params:
        {
          client: this.getClient.id,
          keyword: query ? query : undefined,
          per_page: 100
        }
      }).then(function (response) {
        self.userList = response.data.items;
        self.buttonDisabled = false;
      }, function () {
      });
    },
    showReopenDataCollectionModal(object) {
      let self = this;
      this.comment = '';
      this.reopenError = '';

      this.selectedAssignUsers = [];

      this.loadUsers();

      _.forEach(self.selectedTask.data_users, function (user) {
        self.selectedAssignUsers.push(user);
      })

      this.showModal('reopen-task');
    },
    hideReopenDataCollectionModal() {
      this.selectedAssignUsers = [];
      this.hideModal('reopen-task');
    },
    loadComments(taskId) {
      let self = this;
      let taskActiveId = '';

      this.loadingComments = true;

      if (taskId) {
        taskActiveId = taskId;
      } else {
        taskActiveId = self.task.id;
      }
      piincHttp.get('tasks/' + taskActiveId + '/comments', {
        params:
        {
          client: this.getClient.id,
          per_page: 100,
          sort: 'id',
          order: 'asc'
        }
      }).then(function (response) {
        self.previousComments = [];

        self.previousComments = response.data.items.map(item => ({
          ...item,
          expanded: false
        }));

        self.loadingComments = false;
      }, function () {
      });
    },
    shouldShowAvatar(comment, index) {
      if (index === 0) return true; // always show for first message

      const previous = this.previousComments[index - 1];

      // Compare user IDs (preferred)
      return previous.user.id !== comment.user.id;
    },
    openUsersModal(object) {
      this.selectedItem = object;
      this.showUsersModal = true;
    },
    closeUsersModal() {
      this.selectedItem = {};
      this.showUsersModal = false;
    },
    switchCurrentView(type) {
      this.showLinksSection = false;
      this.showDataCollectionLinksSection = false;
      this.loadComments();
      this.currentView = type;
      if (type == 'default') {
        this.loadGuides('assessment_task');
      } else {
        this.loadGuidesData('data_collection_task');
      }
    },
    showTaskModal(object) {
      let self = this;

      this.error = '';
      this.showLinksSection = false;
      this.showDataCollectionLinksSection = false;

      this.tests = [];
      this.sTableItems = [];
      this.previousComments = [];

      this.loadTaskById(object.id);

      if (object == null && this.tasks && this.tasks.length) {
        self.selectedTask = this.tasks[0];
      }

      // Checking the type of the users so the right view is displayed
      if (this.isOwner(self.selectedTask.project)) {
        // if the user is owner on the project od admin
        this.currentView = 'default';
      } else {
        // Checking the type of the users so the right view is displayed
        if (self.isOwner(self.selectedTask)) {
          self.switchCurrentView('default');
          if (self.selectedTask.code == 'update_measures') {
            self.loadGuidesSystem('system_description_task');
          } else {
            self.loadGuides('assessment_task');
          }
        } else {
          if (self.isDataOwner(self.selectedTask)) {
            self.switchCurrentView('data_collection');
            self.loadGuidesData('data_collection_task');
          }
        }
      }


      this.loadComments(object.id);


      this.showModal('task-modal');
      this.loadTaskGuide();

    },
    loadLinkedControls() {
      let self = this;

      this.buttonDisabled = false;

      piincHttp.get('projects/' + this.selectedTask.project.slug + '/tasks/linked', {
        params:
        {
          task_id: this.selectedTask.id,
          per_page: 100
        }
      }).then(function (response) {
        self.linkedControls = response.data;

        // Create an array to store all media files
        self.allLinkedMediaFiles = [];
        self.allLinkedDataMediaFiles = [];

        let existingLinkedMediaIds = self.selectedTask.linked_media.map(media => media.id);

        self.linkedControls.forEach(task => {
          if (task.media && task.media.length > 0) {
            // Filter media files by collection names and store them in respective arrays
            task.media.forEach(file => {
              if (!existingLinkedMediaIds.includes(file.id)) { // Check if media doesn't already exist in linked_media
                if (file.collection_name === 'data_documents') {
                  self.allLinkedDataMediaFiles.push(file);
                  self.allLinkedMediaFiles.push(file);
                } else if (file.collection_name === 'documents') {
                  self.allLinkedMediaFiles.push(file);
                }
              }
            });
          }
        });

        self.buttonDisabled = false;
      }, function () {
      });
    },
    hideTaskModal() {
      let self = this;
      this.error = '';

      this.editModeResponse = false;
      this.editModeResponseDoc = false;
      this.editModeResponseDocMain = false;
      this.editModeNotes = false;
      this.editModeControlDescription = false;
      this.editModePerformedTest = false;
      this.editModeTestingNotes = false;
      this.editModeConclusion = false;
      this.editModeControlDescriptionDocumentationCollection = false;

      this.taskForm.response = '';
      this.taskForm.notes = '';
      this.taskForm.control_description = '';
      this.taskForm.performed_text = '';
      this.taskForm.testing_notes = '';
      this.taskForm.remarks = '';
      this.taskForm.data_remarks = '';
      this.taskForm.rto = '';
      this.taskForm.rpo = '';
      this.selectedAnswer = [];
      this.selectedDate = '';
      this.selectedAnswerDoc = [];
      this.selectedDateDoc = '';
      this.selectedDataCollectionAnswer = [];

      setTimeout(function () {
        self.selectedTask = {};
      }, 500);

      if (this.taskCompleted) {
        self.$store.commit('storeReloadTasks');
      }

      this.hideModal('task-modal');
    },
    navigateToProject(task) {
      this.$store.commit('storeTaskToolbarState', true);
      this.$store.commit('storeActiveTask', task);
      this.$router.push({ name: 'projects.view', params: { slug: task.project.slug } });
    },
    populateForm() {
      let self = this;


      self.taskForm.remarks = self.selectedTask.remarks;
      self.taskForm.notes = self.selectedTask.notes;
      self.taskForm.control_description = self.selectedTask.control_description;
      self.taskForm.performed_text = self.selectedTask.performed_text;
      self.taskForm.data_remarks = self.selectedTask.data_remarks;
      self.taskForm.testing_notes = self.selectedTask.testing_notes;
      if (self.selectedTask && self.selectedTask.response_type_options) {
        self.allAnswers = JSON.parse(self.selectedTask.response_type_options);
      } else {
        self.allAnswers = []
      }

      if (self.selectedTask && self.selectedTask.response_type_options_doc) {
        self.allAnswersDoc = JSON.parse(self.selectedTask.response_type_options_doc);
      } else {
        self.allAnswersDoc = []
      }


      self.selectedAnswer = [];
      if (self.selectedTask.response) {
        if (self.selectedTask.response_type != 'Datepicker') {
          self.selectedAnswer = _.find(self.allAnswers, function (item) {
            if (item.title === self.selectedTask.response) {
              return self.selectedTask.response;
            }
          });
        } else {
          self.selectedDate = self.selectedTask.response;
        }
      }

      self.selectedAnswerDoc = [];
      if (self.selectedTask.response_doc) {
        if (self.selectedTask.response_type_doc != 'Datepicker') {
          self.selectedAnswerDoc = _.find(self.allAnswersDoc, function (item) {
            if (item.title === self.selectedTask.response_doc) {
              return self.selectedTask.response_doc;
            }
          });
        } else {
          self.selectedDateDoc = self.selectedTask.response_doc;
        }
      }

      self.selectedDataCollectionAnswer = [];
      if (self.selectedTask.data_response) {
        self.selectedDataCollectionAnswer = _.find(self.allAnswers, function (item) {
          if (item === self.selectedTask.data_response) {
            return self.selectedTask.data_response;
          }
        });
      }

      if (!self.selectedAnswer.title && !self.selectedDate.length) {
        self.editModeResponse = true;
      }
      if (!self.selectedAnswerDoc.title && !self.selectedDateDoc.length) {
        self.editModeResponseDoc = true;
      }
      if (!self.selectedAnswerDoc.title && !self.selectedDateDoc.length) {
        self.editModeResponseDocMain = false;
      }
      if (!self.taskForm.notes || !self.taskForm.notes.length) {
        self.editModeNotes = true;
      }
      if (!self.taskForm.control_description || !self.taskForm.control_description.length) {
        self.editModeControlDescription = true;
      }
      if (!self.taskForm.performed_text || !self.taskForm.performed_text.length) {
        self.editModePerformedTest = true;
      }
      if (!self.taskForm.testing_notes || !self.taskForm.testing_notes.length) {
        self.editModeTestingNotes = true;
      }
      if (!self.taskForm.remarks || !self.taskForm.remarks.length) {
        self.editModeConclusion = true;
      }
      if (!self.taskForm.data_remarks || !self.taskForm.data_remarks.length) {
        self.editModeControlDescriptionDocumentationCollection = true;
      }

      this.selectedConfidentialityImpact = [];
      if (self.selectedTask.confidentiality) {
        self.selectedConfidentialityImpact = _.find(self.impactItems, function (item) {
          if (item.value === self.selectedTask.confidentiality) {
            return item;
          }
        });
      }

      this.selectedIntegrityImpact = [];
      if (self.selectedTask.integrity) {
        self.selectedIntegrityImpact = _.find(self.impactItems, function (item) {
          if (item.value === self.selectedTask.integrity) {
            return item;
          }
        });
      }

      this.selectedAvailabilityImpact = []
      if (self.selectedTask.availability) {
        self.selectedAvailabilityImpact = _.find(self.impactItems, function (item) {
          if (item.value === self.selectedTask.availability) {
            return item;
          }
        });
      }

      this.rtoInterval = []
      if (self.selectedTask.rto_type) {
        self.rtoInterval = _.find(self.intervalOptions, function (item) {
          if (item.value === self.selectedTask.rto_type) {
            return item;
          }
        });
      }

      this.rpoInterval = []
      if (self.selectedTask.rpo_type) {
        self.rpoInterval = _.find(self.intervalOptions, function (item) {
          if (item.value === self.selectedTask.rpo_type) {
            return item;
          }
        });
      }

      this.taskForm.rto = this.selectedTask.rto_number;
      this.taskForm.rpo = this.selectedTask.rpo_number;

    },
    showViewGuideModal(object) {
      this.selectedGuide = object;
      this.viewGuideModal = true;
    },
    closeViewGuideModal() {
      this.selectedGuide = '';
      this.viewGuideModal = false;
    },
    openWelcomePage() {
      this.showViewGuideModal(this.welcomeGuide);
    },
    showDropActiveFunction(value) {
      this.showDropActive = value;
    },
    loadTaskGuide() {
      let language = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en';
      let self = this;
      piincHttp.get('guides', {
        params:
        {
          per_page: 1,
          language: 'en',
          type: 'Task',
          scope: 'assessment_task',
          client: this.getClient.slug
        }
      }).then(function (response) {
        if (response.data.items.length) {
          self.welcomeGuide = response.data.items[0];
        }
      }, function () {
      });
    },
    navigateToTask(object) {
      if (this.isOwner(object.model)) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
        if (object.model_type == 'App\\Activity\\Models\\Activity') {
          this.$router.push({ name: 'activities.view', params: { slug: object.model.slug }, query: { task: object.id } });
        }
        if (object.model_type == 'App\\Process\\Models\\Process') {
          this.$router.push({ name: 'processes.view', params: { slug: object.model.slug }, query: { task: object.id } });
        }
        if (object.model_type == 'App\\System\\Models\\System') {
          this.$router.push({ name: 'systems.view', params: { slug: object.model.slug, }, query: { task: object.id } });
        }
        if (object.model_type == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty') {
          this.$router.push({ name: 'contracts.view', params: { slug: object.model.slug, }, query: { task: object.id } });
        }
      }
    },
    isOwner(object) {
      if (!object || !object.users) {

        return false;
      }
      let self = this;
      let allow = false;
      let existingUser = _.find(object.users, function (user) {
        return user.id == self.getUser.id;
      });


      if (existingUser) {
        allow = true;
      } else {
        if (roleCheck('Client admin') || roleCheck('Partition admin') || roleCheck('Validator') || this.getUser.isAdmin) {
          allow = true;
        }
      }

      return allow;
    },
    isDataOwner(object) {
      let self = this;
      let allow = false;
      let existingUser = _.find(object.data_users, function (user) {
        return user.id == self.getUser.id;
      });

      if (existingUser) {
        allow = true;
      } else {
        if (roleCheck('Client admin') || roleCheck('Partition admin') || roleCheck('Validator') || this.getUser.isAdmin) {
          allow = true;
        }
      }

      return allow;
    },
    isCommentOwner(object) {
      let self = this;
      let allow = false;
      let existingUser = object.user.id == this.getUser.id;

      if (existingUser) {
        allow = true;
      } else {
        if (this.getUser.isAdmin) {
          allow = true;
        }
      }

      return allow;
    },
    minimizeTask() {
      this.saveTask();
      var element = document.getElementsByClassName('modal');
      element[0].classList.add("bottom-left");
      // this.submitForm = true
      this.$store.commit('storeActiveTask', this.selectedTask);
      this.$store.commit('storeTaskToolbarState', true);
    },
    addCommentSubmit() {
      let self = this;
      self.buttonDisabled = false;

      let formData = new FormData();

      formData.append("comment", self.comment);

      piincHttp.post('tasks/' + self.selectedTask.id + '/comments', formData).then(function () {
        self.loadTaskById(self.selectedTask.id, true);
        self.loadComments();
        self.showInput = false
        self.comment = '';
      }, function () {
      })
    },
    changeUsersSubmit() {
      let self = this;
      let userIds = [];

      if (this.selectedAssignUsers && this.selectedAssignUsers.length) {
        for (var i = 0; i < this.selectedAssignUsers.length; i++) {
          userIds.push(this.selectedAssignUsers[i].id);
        }
      }

      if (this.selectedAssignUsers && this.selectedAssignUsers.length) {
        piincHttp.put('tasks/' + self.selectedTask.id, {
          data_users: userIds
        }).then(function (response) {
          self.buttonDisabled = false;
          self.loadTaskById(self.selectedTask.id, true);
          self.hideReopenDataCollectionModal();
        }, function (error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })
      } else {
        this.reopenError = '';
        self.buttonDisabled = false;
        if (this.selectedAssignUsers && !this.selectedAssignUsers.length) {
          this.reopenError += ' ' + this.$t('tasks.modal.recipient_error_message');
        }
      }
    },
    reopenFormSubmit() {
      this.buttonDisabled = true;
      let self = this;

      piincHttp.put('tasks/' + self.selectedTask.id, {
        data_status: 'pending',
      }).then(function (response) {
        self.buttonDisabled = false;
        self.loadTaskById(self.selectedTask.id, true);
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })

    },
    completeTask() {
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;
      var moment = require('moment');
      let responseAnswer = '';
      let responseAnswerDoc = '';

      if (
        // -------------------------
        // Attachments
        // -------------------------
        (
          (this.selectedTask &&
            this.selectedTask.add_attachments === 'Mandatory' &&
            (
              (this.selectedTask.media && this.selectedTask.media.length) ||
              (this.selectedTask.links && this.selectedTask.links.length)
            )
          ) ||
          (this.selectedTask && this.selectedTask.add_attachments !== 'Mandatory')
        ) &&

        // -------------------------
        // Description
        // -------------------------
        (
          (this.selectedTask &&
            this.selectedTask.add_description === 'Mandatory' &&
            this.taskForm.remarks
          ) ||
          (this.selectedTask && this.selectedTask.add_description !== 'Mandatory')
        ) &&

        // -------------------------
        // Control description
        // -------------------------
        (
          (this.selectedTask &&
            this.selectedTask.add_control_description === 'Mandatory' &&
            this.taskForm.control_description
          ) ||
          (this.selectedTask && this.selectedTask.add_control_description !== 'Mandatory')
        ) &&

        // -------------------------
        // Notes
        // -------------------------
        (
          (this.selectedTask &&
            this.selectedTask.add_notes === 'Mandatory' &&
            this.taskForm.notes
          ) ||
          (this.selectedTask && this.selectedTask.add_notes !== 'Mandatory')
        ) &&

        // -------------------------
        // Performed text
        // -------------------------
        (
          (this.selectedTask &&
            this.selectedTask.add_performed_text === 'Mandatory' &&
            this.taskForm.performed_text
          ) ||
          (this.selectedTask && this.selectedTask.add_performed_text !== 'Mandatory')
        ) &&

        // -------------------------
        // MAIN response
        // -------------------------
        (
          (this.selectedTask &&
            this.selectedTask.add_response === 'Mandatory' &&
            (
              (this.selectedTask.response_type !== 'Datepicker' &&
                this.selectedAnswer &&
                this.selectedAnswer.title
              ) ||
              (this.selectedTask.response_type === 'Datepicker' &&
                this.selectedDate &&
                this.selectedDate !== ''
              )
            )
          ) ||
          (this.selectedTask && this.selectedTask.add_response !== 'Mandatory')
        ) &&

        // -------------------------
        // DOC response (NEW)
        // -------------------------
        (
          (this.selectedTask &&
            this.selectedTask.add_response_doc === 'Auditor' &&
            (
              (this.selectedTask.response_type_doc !== 'Datepicker' &&
                this.selectedAnswerDoc &&
                this.selectedAnswerDoc.title
              ) ||
              (this.selectedTask.response_type_doc === 'Datepicker' &&
                this.selectedDateDoc &&
                this.selectedDateDoc !== ''
              )
            )
          ) ||
          (this.selectedTask && this.selectedTask.add_response_doc !== 'Auditor')
        )
      ) {

        // -------------------------
        // Build MAIN response
        // -------------------------
        if (this.selectedTask.response_type !== 'Datepicker') {
          responseAnswer = this.selectedAnswer && this.selectedAnswer.title
            ? this.selectedAnswer.title
            : undefined;
        } else {
          responseAnswer = this.selectedDate
            ? moment(this.selectedDate).format('YYYY-MM-DD')
            : undefined;
        }

        // -------------------------
        // Build DOC response
        // -------------------------
        if (this.selectedTask.response_type_doc !== 'Datepicker') {
          responseAnswerDoc = this.selectedAnswerDoc && this.selectedAnswerDoc.title
            ? this.selectedAnswerDoc.title
            : undefined;
        } else {
          responseAnswerDoc = this.selectedDateDoc
            ? moment(this.selectedDateDoc).format('YYYY-MM-DD')
            : undefined;
        }

        let selectedMediaIds = this.selectedLinkedMedia.map(function (media) {
          return media.id;
        });

        let selectedDataMediaIds = this.selectedLinkedDataMedia.map(function (media) {
          return media.id;
        });

        // -------------------------
        // Submit
        // -------------------------
        piincHttp.put('tasks/' + this.selectedTask.id, {
          remarks: this.taskForm.remarks,
          control_description: this.taskForm.control_description,
          notes: this.taskForm.notes,
          testing_notes: this.taskForm.testing_notes,
          performed_text: this.taskForm.performed_text,
          response: responseAnswer,
          response_doc: responseAnswerDoc,
          status: 'completed',
          linked_media: selectedMediaIds,
          linked_data_media: selectedDataMediaIds
        }).then(function () {
          self.buttonDisabled = false;

          if (self.taskList.length > 1) {
            let index = _.findIndex(self.taskList, function (o) {
              return o.id === self.selectedTask.id;
            });

            if (index < self.taskList.length - 1) {
              self.selectedTask = self.taskList[index + 1];
            } else {
              self.selectedTask = self.taskList[0];
            }

            self.taskList.splice(index, 1);
            self.loadTaskById(self.selectedTask.id);
          } else {
            self.taskCompleted = true;
            self.$store.commit('storeTaskToolbarState', false);
            self.$emit('reloadContent');
            self.hideTaskModal();
          }
        }, function (error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        });

      } else {
        // -------------------------
        // Errors
        // -------------------------
        this.error = '';
        self.buttonDisabled = false;

        if (this.selectedTask.add_control_description === 'Mandatory' && !this.taskForm.control_description) {
          this.error += ' ' + this.$t('tasks.modal.control_description_error_message');
        }

        if (this.selectedTask.add_notes === 'Mandatory' && !this.taskForm.notes) {
          this.error += ' ' + this.$t('tasks.modal.notes_error_message');
        }

        if (this.selectedTask.add_performed_text === 'Mandatory' && !this.taskForm.performed_text) {
          this.error += ' ' + this.$t('tasks.modal.performed_test_error_message');
        }

        if (
          this.selectedTask.add_response === 'Mandatory' &&
          (
            !this.selectedAnswer ||
            !this.selectedAnswer.title
          )
        ) {
          this.error += ' ' + this.$t('tasks.modal.response_error_message');
        }

        // 🔴 DOC response error (NEW)
        if (
          this.selectedTask.add_response_doc === 'Auditor' &&
          (
            (this.selectedTask.response_type_doc !== 'Datepicker' &&
              (!this.selectedAnswerDoc || !this.selectedAnswerDoc.title)
            ) ||
            (this.selectedTask.response_type_doc === 'Datepicker' &&
              (!this.selectedDateDoc || this.selectedDateDoc === '')
            )
          )
        ) {
          this.error += ' ' + this.$t('maintenance.questions.create.response_type_error_message');
        }

        if (this.selectedTask.add_description === 'Mandatory' && !this.taskForm.remarks) {
          this.error += ' ' + this.$t('tasks.modal.conclusion_error_message');
        }

        if (
          this.selectedTask.add_attachments === 'Mandatory' &&
          (!this.selectedTask.media || !this.selectedTask.media.length) &&
          (!this.selectedTask.links || !this.selectedTask.links.length)
        ) {
          this.error += ' ' + this.$t('tasks.modal.attachments_error_message');
        }
      }
    },
    reOpenTask() {
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;

      piincHttp.put('tasks/' + this.selectedTask.id, {
        status: 'pending'
      }).then(function (response) {
        self.selectedTask = response.data;
        self.buttonDisabled = false;
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
    },
    completeDataTask() {
      var moment = require('moment');
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;

      if (
        ((this.selectedTask && this.selectedTask.data_collection_add_attachments == 'Mandatory' && ((this.getMedia('data_documents') && this.getMedia('data_documents').length) || (this.getLinks('data_documents') && this.getLinks('data_documents').length))) ||
          (this.selectedTask && this.selectedTask.data_collection_add_attachments != 'Mandatory')) &&
        ((this.selectedTask && this.selectedTask.data_collection_add_description == 'Mandatory' && this.taskForm.data_remarks) ||
          (this.selectedTask && this.selectedTask.data_collection_add_description != 'Mandatory'))
      ) {
        piincHttp.put('tasks/' + this.selectedTask.id, {
          data_remarks: this.taskForm.data_remarks,
          data_status: 'completed'
        }).then(function (response) {
          self.buttonDisabled = false;
          if (self.taskList.length > 1) {
            let index = _.findIndex(self.taskList, function (o) {
              return o.id == self.selectedTask.id
            });
            if (index < self.taskList.length - 1) {
              self.selectedTask = self.taskList[index + 1];
            } else {
              self.selectedTask = self.taskList[0];
            }
            self.taskList.splice(index, 1);
            self.loadTaskById(self.selectedTask.id);
          } else {
            self.$store.commit('storeTaskToolbarState', false);
            if (self.isOwner(self.selectedTask)) {
              self.currentView = 'default';
              self.loadTaskById(self.selectedTask.id);
            } else {
              self.hideTaskModal();
            }
            self.$emit('reloadContent');
          }
        }, function (error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })
      } else {
        this.error = '';
        self.buttonDisabled = false;
        if (this.selectedTask.data_collection_add_description == 'Mandatory' && !this.taskForm.data_remarks) {
          this.error += ' ' + this.$t('tasks.modal.comment_error_message');
        }
        if ((this.selectedTask.data_collection_add_attachments == 'Mandatory' && this.getMedia('data_documents') && !this.getMedia('data_documents').length) && (this.selectedTask.data_collection_add_attachments == 'Mandatory' && this.getLinks('data_documents') && !this.getLinks('data_documents').length)) {
          this.error += ' ' + this.$t('tasks.modal.attachments_error_message');
        }

      }
    },
    saveDataTask() {
      var moment = require('moment');
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;

      if (
        ((this.selectedTask && this.selectedTask.data_collection_add_attachments == 'Mandatory' && ((this.getMedia('data_documents') && this.getMedia('data_documents').length) || (this.getLinks('data_documents') && this.getLinks('data_documents').length))) ||
          (this.selectedTask && this.selectedTask.data_collection_add_attachments != 'Mandatory')) &&
        ((this.selectedTask && this.selectedTask.data_collection_add_description == 'Mandatory' && this.taskForm.data_remarks) ||
          (this.selectedTask && this.selectedTask.data_collection_add_description != 'Mandatory'))
      ) {
        piincHttp.put('tasks/' + this.selectedTask.id, {
          data_remarks: this.taskForm.data_remarks
        }).then(function (response) {
          self.buttonDisabled = false;
          if (self.taskList.length > 1) {
            let index = _.findIndex(self.taskList, function (o) {
              return o.id == self.selectedTask.id
            });
            if (index < self.taskList.length - 1) {
              self.selectedTask = self.taskList[index + 1];
            } else {
              self.selectedTask = self.taskList[0];
            }
            self.taskList.splice(index, 1);
            self.loadTaskById(self.selectedTask.id);
          } else {
            self.$store.commit('storeTaskToolbarState', false);
            if (self.isOwner(self.selectedTask)) {
              self.currentView = 'default';
              self.loadTaskById(self.selectedTask.id);
            } else {
              self.hideTaskModal();
            }
          }
        }, function (error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })
      } else {
        this.error = '';
        self.buttonDisabled = false;
        if (this.selectedTask.data_collection_add_description == 'Mandatory' && !this.taskForm.data_remarks) {
          this.error += ' ' + this.$t('tasks.modal.comment_error_message');
        }
        if ((this.selectedTask.data_collection_add_attachments == 'Mandatory' && this.getMedia('data_documents') && !this.getMedia('data_documents').length) && (this.selectedTask.data_collection_add_attachments == 'Mandatory' && this.getLinks('data_documents') && !this.getLinks('data_documents').length)) {
          this.error += ' ' + this.$t('tasks.modal.attachments_error_message');
        }

      }
    },
    reOpenDataTask() {
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;

      piincHttp.put('tasks/' + this.selectedTask.id, {
        data_status: 'pending'
      }).then(function (response) {
        self.selectedTask = response.data;
        self.buttonDisabled = false;
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
    },
    completeSystemRiskTask() {
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;
      this.error = '';

      if (
        this.taskForm.remarks != '' &&
        this.selectedConfidentialityImpact && this.selectedConfidentialityImpact.value &&
        this.selectedIntegrityImpact && this.selectedIntegrityImpact.value &&
        this.selectedAvailabilityImpact && this.selectedAvailabilityImpact.value &&
        this.taskForm.rto != '' &&
        this.taskForm.rpo != '' &&
        this.rtoInterval && this.rtoInterval.value &&
        this.rpoInterval && this.rpoInterval.value
      ) {
        piincHttp.put('tasks/' + this.selectedTask.id, {
          remarks: this.taskForm.remarks,
          confidentiality: this.selectedConfidentialityImpact ? this.selectedConfidentialityImpact.value : '',
          integrity: this.selectedIntegrityImpact ? this.selectedIntegrityImpact.value : '',
          availability: this.selectedAvailabilityImpact ? this.selectedAvailabilityImpact.value : '',
          rto_number: this.taskForm.rto,
          rto_type: this.rtoInterval ? this.rtoInterval.value : '',
          rpo_number: this.taskForm.rpo,
          rpo_type: this.rtoInterval ? this.rpoInterval.value : '',
          status: 'completed'
        }).then(function (response) {
          self.$toastr('success', self.$t('tasks.modal.success'));
          self.buttonDisabled = false;

          if (self.taskList.length > 1) {
            let index = _.findIndex(self.taskList, function (o) {
              return o.id == self.selectedTask.id
            })
            if (index < self.taskList.length - 1) {
              self.selectedTask = self.taskList[index + 1];
            } else {
              self.selectedTask = self.taskList[0];
            }
            self.taskList.splice(index, 1);
            self.loadTaskById(self.selectedTask.id);
          } else {
            self.hideModal('task-modal');
          }
        }, function (error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })
      } else {
        this.error = '';
        self.buttonDisabled = false;
        this.error = this.$t('tasks.modal.all_fields_error_message');
      }
    },
    saveTask() {
      var moment = require('moment');
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;
      let responseAnswer = '';
      let responseAnswerDoc = '';
      if (this.selectedTask.response_type != 'Datepicker') {
        responseAnswer = this.selectedAnswer && this.selectedAnswer.title ? this.selectedAnswer.title : '';
      } else {
        responseAnswer = this.selectedDate ? moment(this.selectedDate).format('YYYY-MM-DD') : '';
      }

      if (this.selectedTask.response_type_doc != 'Datepicker') {
        responseAnswerDoc = this.selectedAnswerDoc && this.selectedAnswerDoc.title ? this.selectedAnswerDoc.title : '';
      } else {
        responseAnswerDoc = this.selectedDateDoc ? moment(this.selectedDateDoc).format('YYYY-MM-DD') : '';
      }

      let selectedMediaIds = this.selectedLinkedMedia.map(media => media.id);
      let selectedDataMediaIds = this.selectedLinkedDataMedia.map(media => media.id);

      piincHttp.put('tasks/' + this.selectedTask.id, {
        data_remarks: this.taskForm.data_remarks,
        remarks: this.taskForm.remarks,
        performed_text: this.taskForm.performed_text,
        control_description: this.taskForm.control_description,
        notes: this.taskForm.notes,
        testing_notes: this.taskForm.testing_notes,
        confidentiality: this.selectedConfidentialityImpact ? this.selectedConfidentialityImpact.value : '',
        integrity: this.selectedIntegrityImpact ? this.selectedIntegrityImpact.value : '',
        availability: this.selectedAvailabilityImpact ? this.selectedAvailabilityImpact.value : '',
        rto_number: this.taskForm.rto,
        rto_type: this.rtoInterval ? this.rtoInterval.value : '',
        rpo_number: this.taskForm.rpo,
        rpo_type: this.rtoInterval ? this.rpoInterval.value : '',
        response: responseAnswer,
        response_doc: responseAnswerDoc,
        data_response: this.selectedDataCollectionAnswer && this.selectedDataCollectionAnswer.length ? this.selectedDataCollectionAnswer : '',
        linked_media: selectedMediaIds,
        linked_data_media: selectedDataMediaIds
      }).then(function (response) {
        self.buttonDisabled = false;
        self.$emit('reloadContent', response.data);
        self.hideTaskModal();
        self.$toastr('success', self.$t('tasks.modal.success'))
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })

    },
    updateLinkedMedia() {
      let self = this;
      let selectedMediaIds = this.selectedLinkedMedia.map(media => media.id);

      piincHttp.put('tasks/' + this.selectedTask.id, {
        linked_media: selectedMediaIds,
      }).then(function (response) {
        self.loadTaskById(self.selectedTask.id, true);
        self.$emit('reloadContent', response.data);
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
    },
    updateLinkedDataMedia() {
      let self = this;
      let selectedMediaIds = this.selectedLinkedDataMedia.map(media => media.id);

      piincHttp.put('tasks/' + this.selectedTask.id, {
        linked_data_media: selectedMediaIds,
      }).then(function (response) {
        self.loadTaskById(self.selectedTask.id, true);
        self.$emit('reloadContent', response.data);
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
    },
    updateControlDescription() {
      const self = this;

      piincHttp.put('tasks/' + this.selectedTask.id, {
        control_description: this.taskForm.control_description,
      }).then(function (response) {
        self.selectedTask = response.data;
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
      this.editModeControlDescription = false
    },
    discardControlDescription() {

      this.taskForm.control_description = this.selectedTask.control_description
      this.editModeControlDescription = false
    },
    updateDataRemarks() {
      const self = this;

      piincHttp.put('tasks/' + this.selectedTask.id, {
        data_remarks: this.taskForm.data_remarks,
      }).then(function (response) {
        self.selectedTask = response.data;
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
      this.editModeControlDescriptionDocumentationCollection = false
    },
    discardDataRemarks() {

      this.taskForm.data_remarks = this.selectedTask.data_remarks
      this.editModeControlDescriptionDocumentationCollection = false
    },
    updatePerformedTest() {
      const self = this;

      piincHttp.put('tasks/' + this.selectedTask.id, {
        performed_text: this.taskForm.performed_text,
      }).then(function (response) {
        self.selectedTask = response.data;
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
      this.editModePerformedTest = false
    },
    discardPerformedTest() {

      this.taskForm.performed_text = this.selectedTask.performed_text
      this.editModePerformedTest = false
    },
    updateTestingNotes() {
      const self = this;

      piincHttp.put('tasks/' + this.selectedTask.id, {
        testing_notes: this.taskForm.testing_notes,
      }).then(function (response) {
        self.selectedTask = response.data;
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
      this.editModeTestingNotes = false
    },
    discardTestingNotes() {

      this.taskForm.testing_notes = this.selectedTask.testing_notes
      this.editModeTestingNotes = false
    },
    updateNotes() {
      const self = this;

      piincHttp.put('tasks/' + this.selectedTask.id, {
        notes: this.taskForm.notes,
      }).then(function (response) {
        self.selectedTask = response.data;
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
      this.editModeNotes = false
    },
    discardNotes() {

      this.taskForm.notes = this.selectedTask.notes
      this.editModeNotes = false
    },
    updateResponse() {
      const self = this;
      var moment = require('moment');
      let responseAnswer = '';
      if (this.selectedTask.response_type != 'Datepicker') {
        responseAnswer = this.selectedAnswer && this.selectedAnswer.title ? this.selectedAnswer.title : '';
      } else {
        responseAnswer = this.selectedDate ? moment(this.selectedDate).format('YYYY-MM-DD') : '';
      }

      piincHttp.put('tasks/' + this.selectedTask.id, {
        response: responseAnswer,
      }).then(function (response) {
        self.selectedTask = response.data;
        self.getIcon(response.data);
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
      this.editModeResponse = false
    },
    discardResponse() {
      const self = this;

      this.taskForm.response = this.selectedTask.response;

      if (self.selectedTask && self.selectedTask.response_type_options) {
        self.allAnswers = JSON.parse(self.selectedTask.response_type_options);
      } else {
        self.allAnswers = []
      }

      self.selectedAnswer = [];
      if (self.selectedTask.response) {
        if (self.selectedTask.response_type != 'Datepicker') {
          self.selectedAnswer = _.find(self.allAnswers, function (item) {
            if (item.title === self.selectedTask.response) {
              return self.selectedTask.response;
            }
          });
        } else {
          self.selectedDate = self.selectedTask.response;
        }
      }

      this.editModeResponse = false;
    },
    updateResponseDoc() {
      const self = this;

      let responseAnswer = '';
      if (this.selectedTask.response_type_doc != 'Datepicker') {
        responseAnswer = this.selectedAnswerDoc && this.selectedAnswerDoc.title ? this.selectedAnswerDoc.title : '';
      } else {
        responseAnswer = this.selectedDateDoc ? moment(this.selectedDateDoc).format('YYYY-MM-DD') : '';
      }

      piincHttp.put('tasks/' + this.selectedTask.id, {
        response_doc: responseAnswer,
      }).then(function (response) {
        self.selectedTask = response.data;
        self.getIcon(response.data);
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
      this.editModeResponseDoc = false
      this.editModeResponseDocMain = false
    },
    discardResponseDoc() {
      const self = this;

      this.taskForm.response_doc = this.selectedTask.response_doc;

      if (self.selectedTask && self.selectedTask.response_type_options_doc) {
        self.allAnswers = JSON.parse(self.selectedTask.response_type_options_doc);
      } else {
        self.allAnswers = []
      }

      self.selectedAnswerDoc = [];
      if (self.selectedTask.response_doc) {
        if (self.selectedTask.response_type_doc != 'Datepicker') {
          self.selectedAnswerDoc = _.find(self.allAnswers, function (item) {
            if (item.title === self.selectedTask.response_doc) {
              return self.selectedTask.response_doc;
            }
          });
        } else {
          self.selectedDateDoc = self.selectedTask.response_doc;
        }
      }

      this.editModeResponseDoc = false;
      this.editModeResponseDocMain = false;
    },
    updateConclusion() {
      const self = this;

      piincHttp.put('tasks/' + this.selectedTask.id, {
        remarks: this.taskForm.remarks,
      }).then(function (response) {
        self.selectedTask = response.data;
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
      this.editModeConclusion = false
    },
    discardConclusion() {
      this.taskForm.remarks = this.selectedTask.remarks;
      this.editModeConclusion = false;
    },

    openDeleteAttachmentModal(object) {
      this.selectedFile = object;
      this.showDeleteAttachmentModal = true;
    },
    closeDeleteAttachmentModal() {
      this.selectedFile = {};
      this.showDeleteAttachmentModal = false;
      this.loadTaskById(this.selectedTask.id, true);
      if (this.selectedTest && this.selectedTest.id) {
        this.loadTest(this.selectedTest.id);
      }

    },
    openDeleteLinkedAttachmentModal(object) {
      this.selectedFile = object;
      this.showDeleteLinkedAttachmentModal = true;
    },
    closeDeleteLinkedAttachmentModal() {
      this.selectedFile = {};
      this.showDeleteLinkedAttachmentModal = false;
      this.loadTaskById(this.selectedTask.id, true);

    },
    openDeleteLinkModal(object) {
      this.selectedLink = object;
      this.showDeleteLinkModal = true;
    },
    closeDeleteLinkModal() {
      this.selectedLink = {};
      this.showDeleteLinkModal = false;
      this.loadTaskById(this.selectedTask.id, true);
    },
    openDeleteCommentModal(object) {
      this.selectedComment = object;
      this.showDeleteCommentModal = true;
    },
    closeDeleteCommentModal() {
      this.selectedComment = {};
      this.showDeleteCommentModal = false;
      this.loadComments();
    },
    handleLink() {
      let self = this;
      let formData = new FormData();

      if (!this.inputLink.startsWith('http')) {
        this.inputLink = 'http://' + this.inputLink;
      }

      formData.append("url", this.inputLink);
      formData.append("name", this.inputLinkName);
      formData.append("collection", "task");
      formData.append("model_type", this.selectedTask.who_am_i);
      formData.append("model_id", this.selectedTask.id);

      piincHttp.post('links', formData).then(function () {
        self.inputLink = '';
        self.inputLinkName = '';
        self.hideCreateLinkModal();
        self.loadTaskById(self.selectedTask.id, true);
        self.showInput = false;
      }, function () {
      })
    },
    handleDataCollectionLink() {
      let self = this;
      let formData = new FormData();

      if (!this.inputLink.startsWith('http')) {
        this.inputLink = 'http://' + this.inputLink;
      }

      formData.append("url", this.inputLink);
      formData.append("name", this.inputLinkName);
      formData.append("collection", "data_documents");
      formData.append("model_type", this.selectedTask.who_am_i);
      formData.append("model_id", this.selectedTask.id);

      piincHttp.post('links', formData).then(function () {
        self.inputLink = '';
        self.inputLinkName = '';
        self.loadTaskById(self.selectedTask.id, true);
        self.showDataCollectionLinksSection = false;
      }, function () {
      })
    },
    downloadMedia(object) {
      piincHttp.get('documents/' + object.id + '/download', {
        responseType: 'blob',
        params: {
          task: this.selectedTask.id
        }
      }).then(function (response) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.download = object.file_name;

        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }, function () {
      });
    },
    loadTaskById(id, ignorePopulate) {
      let self = this;
      piincHttp.get('tasks/' + id).then(function (response) {
        self.selectedTask = response.data;
        if (self.isOwner(self.selectedTask)) {
          self.loadObservations(self.selectedTask.id);
        }
        self.loadLinkedControls();
        self.loadTests();
        self.loadQaComments();
        self.project_progress = self.selectedTask.project.user_progress.progress;
        if (!ignorePopulate) {
          self.populateForm();
          // Checking the type of the users so the right view is displayed
          if (self.isOwner(self.selectedTask)) {
            self.switchCurrentView('default');
            if (self.selectedTask.code == 'update_measures') {
              self.loadGuidesSystem('system_description_task');
            } else {
              self.loadGuides('assessment_task');
            }
          } else {
            if (self.isDataOwner(self.selectedTask)) {
              self.switchCurrentView('data_collection');
            }
          }
        }
      }, function () {
      });
    },
    onFileChangeEdit(file) {
      let self = this;
      let formData = new FormData();
      let sizeError = false;

      // Append list of attachments to FormData
      for (var i = 0; i < this.files.length; i++) {
        // Equal to 10 MB
        if (this.files[i].size > 31457280) {
          sizeError = true;
        }
        formData.append("document[]", this.files[i].file);
      }

      formData.append("name", "documents");
      formData.append("model_type", this.selectedTask.who_am_i);
      formData.append("model_id", this.selectedTask.id);

      if (sizeError) {
        this.sizeError = this.$t('system.file_size_30');
        this.files = [];
      } else {
        piincHttp.post('documents', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function () {
          self.error = '';
          self.sizeError = '';
          self.loadTaskById(self.selectedTask.id, true);
          self.files = [];
        }, function (error) {
          self.error = error.data.message;
          if (error.data.errors['document.0']) {
            self.error += ' ' + error.data.errors['document.0'][0];
          }
        })
      }
    },
    onTestFileChange(file) {
      let self = this;
      let formData = new FormData();
      let sizeError = false;

      // Append list of attachments to FormData
      for (var i = 0; i < this.test_files.length; i++) {
        // Equal to 10 MB
        if (this.test_files[i].size > 31457280) {
          sizeError = true;
        }
        formData.append("document[]", this.test_files[i].file);
      }

      formData.append("name", "documents");
      formData.append("collection", "documents");
      formData.append("model_type", this.selectedTest.who_am_i);
      formData.append("model_id", this.selectedTest.id);

      if (sizeError) {
        this.error = this.$t('system.file_size_30')
        this.test_files = [];
      } else {
        piincHttp
          .post('documents', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(() => {
            this.error = '';
            this.loadTest(this.selectedTest.id);
            this.test_files = [];
          })
          .catch((error) => {
            this.error = error.data.message;
            if (error.data.errors['document.0']) {
              this.error += ' ' + error.data.errors['document.0'][0];
            }
          });
      }
    },
    onDataFileChange(file) {
      let self = this;
      let formData = new FormData();
      let sizeError = false;

      // Append list of attachments to FormData
      for (var i = 0; i < this.data_collection_files.length; i++) {
        // Equal to 10 MB
        if (this.data_collection_files[i].size > 31457280) {
          sizeError = true;
        }
        formData.append("document[]", this.data_collection_files[i].file);
      }

      formData.append("name", "documents");
      formData.append("collection", "data_documents");
      formData.append("model_type", this.selectedTask.who_am_i);
      formData.append("model_id", this.selectedTask.id);

      if (sizeError) {
        this.error = this.$t('system.file_size_30')
        this.data_collection_files = [];
      } else {
        piincHttp.post('documents', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function () {
          self.error = '';
          self.loadTaskById(self.selectedTask.id, true);
          self.data_collection_files = [];
        }, function (error) {
          self.error = error.data.message;
          if (error.data.errors['document.0']) {
            self.error += ' ' + error.data.errors['document.0'][0];
          }
        })
      }
    },
    loadObservations(task_id) {
      let self = this;

      // If page is not defined, set page to default 1
      let pageNumber = 1;

      this.loadingObservations = true;

      piincHttp.get('projects/' + self.selectedTask.project.slug + '/observations', {
        params:
        {
          page: pageNumber,
          client: this.getClient.slug,
          task_id: task_id
        }
      }).then(function (response) {
        if (response.data && response.data.items) {
          self.sTableItems = response.data.items;
        }
        // Set number of total items
        self.totalRows = response.data.total_count;
        self.loadingObservations = false;
      }, function () {
      });
    },
    deleteObservation(observation) {
      let self = this;

      self.loadingObservations = true;

      piincHttp.delete(
        'projects/' + self.selectedTask.project.slug + '/observations/' + observation.id
      )
        .then(function () {
          // Refresh the list after deletion
          self.loadObservations(self.selectedTask.id);
          self.hideSConfirmDeleteModal();
        })
        .catch(function (error) {
          console.error('Error deleting observation:', error);
          self.loadingObservations = false;
        });
    },
    showEditModal(object) {
      let self = this;
      this.error = '';
      this.selectedS = object

      this.editForm.name = object.name
      this.editForm.description = object.description

      if (this.selectedTask.project.type != 'control_assessment') {
        this.selectedScope = []
        if (object.scope && object.scope.id) {
          this.selectedScope = _.find(this.scopeItems, function (item) {
            return item.id === object.scope.id;
          });
        }
      } else {

      }

      this.selectedImpact = []
      if (object.impact_assessment) {
        this.selectedImpact = _.find(this.impactItems, function (item) {
          return item.value === object.impact_assessment;
        });
      }

      this.showModal('edit-observation')
    },
    editObservationFormSubmit(evt) {
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;
      evt.preventDefault();

      this.editForm.impact_assessment = this.selectedImpact ? this.selectedImpact.value : '';

      if (this.activity && this.activity.type == 'control_assessment') {
        if (this.selectedTask && this.selectedTask.id) {
          this.editForm.scope_id = this.selectedTask ? this.selectedTask.id : '';
        }
      } else {
        this.editForm.scope_id = this.selectedScope ? this.selectedScope.id : '';
      }

      if (this.selectedImpact && this.selectedImpact.value) {
        piincHttp.put('projects/' + this.$route.params.slug + '/observations/' + this.selectedS.id, this.editForm).then(function (response) {
          self.hideEditModal();
          self.loadObservations(self.selectedTask.id);
          self.$toastr('success', self.$t('projects.observations.update.success'))
          self.buttonDisabled = false;
        }, function (error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
            if (error.data.errors.users) {
              self.error += ' ' + error.data.errors.users[0]
            }
          }
        })
      } else {
        this.error = '';
        self.buttonDisabled = false;
        if (!this.selectedScope || (this.selectedScope && !this.selectedScope.id)) {
          this.error += this.$t('projects.observations.create.scope_error_message')
        }
        if (!this.selectedImpact || (this.selectedImpact && !this.selectedImpact.value)) {
          this.error += ' ' + this.$t('projects.observations.create.impact_error_message')
        }
      }
    },
    hideEditModal() {
      this.selectedS = {}
      this.hideModal('edit-observation')
    },
    hideEditTestModal() {
      this.selectedS = {}
      this.hideModal('create-test')
    },
    hideUpdateTestModal() {
      this.selectedS = {}
      this.hideModal('update-test')
    },
    hideShowTestModal() {
      this.selectedS = {}
      this.hideModal('show-test')
    },
    showSConfirmDeleteModal(object) {
      this.itemToDelete = object
      this.showModal('delete-observation')
    },
    showTestConfirmDeleteModal(object) {
      this.itemToDelete = object
      this.showModal('delete-test')
    },
    hideSConfirmDeleteModal() {
      this.itemToDelete = {}
      this.hideModal('delete-observation')
    },
    hideTestConfirmDeleteModal() {
      this.itemToDelete = {}
      this.hideModal('delete-test')
    },
    handleCloseViewModal() {
      this.loadObservations(this.selectedTask.id);
      this.viewObservationModal = false;
      this.selectedObservation = []
    },
    openViewModal(object) {
      this.selectedObservation = object
      this.viewObservationModal = true
    },
    onDragOver(event) {
      // Optional: You can handle visual cues when dragging over the area.
    },
    processFiles(fileList) {
      // Process the list of files
      for (let i = 0; i < fileList.length; i++) {
        this.files.push(fileList[i]);
      }

      let self = this;
      let formData = new FormData();
      let sizeError = false;

      // Append list of attachments to FormData
      for (var i = 0; i < this.files.length; i++) {
        // Equal to 10 MB
        if (this.files[i].size > 31457280) {
          sizeError = true;
        }
        formData.append("document[]", this.files[i]);
      }

      formData.append("name", "documents");
      formData.append("model_type", this.selectedTask.who_am_i);
      formData.append("model_id", this.selectedTask.id);

      if (sizeError) {
        this.sizeError = this.$t('system.file_size_30');
        this.files = [];
      } else {
        piincHttp.post('documents', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function () {
          self.error = '';
          self.sizeError = '';
          self.loadTaskById(self.selectedTask.id, true);
          self.files = [];
        }, function (error) {
          self.error = error.data.message;
          if (error.data.errors['document.0']) {
            self.error += ' ' + error.data.errors['document.0'][0];
          }
        })
      }

    },

    processFilesDocumentation(fileList) {
      // Process the list of files
      for (let i = 0; i < fileList.length; i++) {
        this.data_collection_files.push(fileList[i]);
      }

      let self = this;
      let formData = new FormData();
      let sizeError = false;

      // Append list of attachments to FormData
      for (var i = 0; i < this.data_collection_files.length; i++) {
        // Equal to 10 MB
        if (this.data_collection_files[i].size > 31457280) {
          sizeError = true;
        }
        formData.append("document[]", this.data_collection_files[i]);
      }

      formData.append("name", "documents");
      formData.append("collection", "data_documents");
      formData.append("model_type", this.selectedTask.who_am_i);
      formData.append("model_id", this.selectedTask.id);

      if (sizeError) {
        this.error = this.$t('system.file_size_30')
        this.data_collection_files = [];
      } else {
        piincHttp.post('documents', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function () {
          self.error = '';
          self.loadTaskById(self.selectedTask.id, true);
          self.data_collection_files = [];
        }, function (error) {
          self.error = error.data.message;
          if (error.data.errors['document.0']) {
            self.error += ' ' + error.data.errors['document.0'][0];
          }
        })
      }

    },
    onFileDrop(event) {
      // Handle the file drop, prevent default to stop the default behavior
    },
    handleDrop(event) {
      event.preventDefault(); // Prevent the default file-open behavior
      const files = event.dataTransfer.files; // Get the dropped files
      if (files.length) {
        this.processFiles(files); // Call a custom method to handle the files
      }
    },
    handleDropDocumentation(event) {
      event.preventDefault(); // Prevent the default file-open behavior
      const data_collection_files = event.dataTransfer.files; // Get the dropped files
      if (data_collection_files.length) {
        this.processFilesDocumentation(data_collection_files); // Call a custom method to handle the files
      }
    },
    hideDropActiveFunction() {
      // Handle when drop area becomes inactive
    },
  },
  created() {
    // this.loadTaskById(this.task.id);
  }
}
</script>
<style scoped>
.b-modal .modal-title {
  text-align: center;
  width: 100%;
  /* Ensures full width for proper centering */
  margin: 0 auto;
  /* Centers the title */
}
</style>
